(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9918);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/main.js + 241 modules
var main = __webpack_require__(5452);
// EXTERNAL MODULE: ./src/hooks/AppContext.tsx + 5 modules
var AppContext = __webpack_require__(6833);
// EXTERNAL MODULE: ./src/interfaces/context/appContextInterfaces.ts
var appContextInterfaces = __webpack_require__(4182);
// EXTERNAL MODULE: ./src/utils/tracking.tsx + 1 modules
var tracking = __webpack_require__(5969);
// EXTERNAL MODULE: ./src/utils/jobRendererAxiosClient.ts
var jobRendererAxiosClient = __webpack_require__(6750);
;// CONCATENATED MODULE: ./src/utils/location.ts




/**
 * Get data from Carmen using requesters ip address by default
 * @param ip optional IP address to lookup
 */ var getCarmenData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ip) {
        var ref, _publicRuntimeConfig, apiRequestTimeoutMs, carmenApiHost, suffix, carmenUrl, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs, carmenApiHost = _publicRuntimeConfig.carmenApiHost;
                    suffix = ip ? "/ip/".concat(ip) : "/me";
                    carmenUrl = "".concat(carmenApiHost).concat(suffix);
                    _ctx.next = 5;
                    return jobRendererAxiosClient/* jobRendererAxiosClient.get */.V.get(carmenUrl, {
                        timeout: apiRequestTimeoutMs
                    });
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCarmenData(ip) {
        return _ref.apply(this, arguments);
    };
}();
var locationIsRemote = function(location) {
    return [
        "Flexible / Remote",
        "Remote / Flexible"
    ].map(function(a) {
        return a.toLowerCase();
    }).includes(location === null || location === void 0 ? void 0 : location.value.toLowerCase());
};

// EXTERNAL MODULE: ./src/utils/api.ts
var api = __webpack_require__(1557);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
;// CONCATENATED MODULE: ./src/hooks/useContentPercentViewed.tsx




/**
 * Returns list of objects which returns position of
 * main element for each scroll threshold
 */ var getItemsToTrack = function() {
    var element = document.querySelector("main");
    var elementTop = element.offsetTop;
    var elementHeight = element.offsetHeight;
    var thresholds = [
        25,
        50,
        75,
        100
    ];
    var itemsToTrack = [];
    thresholds.forEach(function(threshold) {
        var elementPosition = elementHeight / 100 * threshold + elementTop;
        itemsToTrack.push({
            top: elementPosition,
            bottom: elementPosition,
            progress: threshold
        });
    });
    return itemsToTrack;
};
var date = new Date();
var loadTime = date.getTime();
/**
 * useContentPercentViewed will return the scroll progress
 * for each scroll percentage threshold.
 */ var useContentPercentViewed = function() {
    if (!(0,browser/* isBrowser */.jU)() || !document.querySelector("main")) {
        return null;
    }
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), state = ref[0], setState = ref[1];
    var elementItemsToTrack = getItemsToTrack();
    var trackItems = function(itemsToTrack) {
        var topOfScreen = window.pageYOffset;
        var bottomOfScreen = topOfScreen + window.innerHeight;
        itemsToTrack.forEach(function(item) {
            var isTopInViewport = item.top > topOfScreen && item.top < bottomOfScreen;
            var isBottomInViewport = item.bottom > topOfScreen && item.bottom < bottomOfScreen;
            var isMiddleEltInViewport = item.top < topOfScreen && item.bottom > bottomOfScreen;
            var isProgressTracked = state.find(function(stateObj) {
                return stateObj.progress === item.progress;
            });
            if (!isProgressTracked && (isTopInViewport || isBottomInViewport || isMiddleEltInViewport)) {
                setState((0,_to_consumable_array/* default */.Z)(state).concat([
                    {
                        progress: item.progress,
                        elapsed_time: (new Date().getTime() - loadTime) / 1000,
                        viewport_height: bottomOfScreen - topOfScreen
                    }
                ]));
            }
        });
    };
    react.useEffect(function() {
        var handleScroll = function() {
            trackItems(elementItemsToTrack);
        };
        handleScroll();
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        state
    ]);
    return state;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(4924);
;// CONCATENATED MODULE: ./src/utils/featureFlags.ts





/**
 * Take a name and determine if the feature flag is activated
 * based on environment variable and query params.
 */ var isFeatureFlagActive = function(name, query, config) {
    if (name in query) {
        return isTruthy(query[name]);
    }
    if ((config === null || config === void 0 ? void 0 : config[name]) !== undefined) {
        return (config === null || config === void 0 ? void 0 : config[name]) === true || (config === null || config === void 0 ? void 0 : config[name]) === "true";
    }
    return false;
};
/**
 * Returns a list of all existing flags in the config.
 */ var getFeatureFlags = function() {
    var publicRuntimeConfig = (0,config["default"])().publicRuntimeConfig;
    return Object.keys(publicRuntimeConfig).reduce(function(prev, curr) {
        if (/^FEATURE_FLAG/.test(curr)) {
            prev.push(curr);
        }
        return prev;
    }, []);
};
/**
 * Returns all active flags in the config and/or query params.
 */ var getActiveFeatureFlags = function(context) {
    var query = context.query;
    var publicRuntimeConfig = getConfig().publicRuntimeConfig;
    var featureFlagsInQuery = getFeatureFlags().reduce(function(featureFlags, featureFlag) {
        return _object_spread_props(_object_spread({}, featureFlags), _define_property({}, featureFlag, isFeatureFlagActive(featureFlag, query, publicRuntimeConfig)));
    }, {});
    return featureFlagsInQuery;
};


;// CONCATENATED MODULE: ./src/hooks/FeatureFlagsContext.tsx






var defaultFeatureFlagsState = Object.keys(getFeatureFlags()).reduce(function(featureFlags, featureFlag) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, featureFlags), (0,src_define_property/* default */.Z)({}, featureFlag, false));
}, {});
var FeatureFlagsContext = /*#__PURE__*/ react.createContext(defaultFeatureFlagsState);
var FeatureFlagsProvider = function(props) {
    var featureFlags = props.featureFlags, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext.Provider, {
        value: featureFlags,
        children: children
    });
};
var useFeatureFlagsState = function() {
    var context = react.useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error("useFeatureFlagsState must be used within the FeatureFlagsProvider");
    }
    return context;
};
FeatureFlagsProvider.displayName = "FeatureFlagsProvider";
useFeatureFlagsState.displayName = "useFeatureFlagsState";


;// CONCATENATED MODULE: ./src/hooks/useSessionStorage.tsx


var useSessionStorage = function(key) {
    if (!(0,browser/* isBrowser */.jU)()) {
        return [
            null,
            function() {}
        ];
    }
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var ref = (0,react.useState)(function() {
        return(// Get from session storage by key
        window.sessionStorage.getItem(key));
    }), storedValue = ref[0], setStoredValue = ref[1];
    // Return a wrapped version of useState's setter function that
    // persists the new value to sessionStorage.
    var setValue = function(value) {
        // Save state
        setStoredValue(value);
        // Save to session storage
        window.sessionStorage.setItem(key, value);
    };
    return [
        storedValue,
        setValue
    ];
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./src/components/JobIndividualPageLayout.tsx




/* eslint-disable camelcase */ 


var JobIndividualPageLayout = function(props) {
    var children = props.children, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    var user = (0,AppContext/* useAppState */.mr)().user;
    var pageProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restProps), {
        user: user,
        staticMobileHeader: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* PageLayout */.Xg, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pageProps), {
        children: children
    }));
};


;// CONCATENATED MODULE: ./src/utils/dates.ts
var day = 1000 * 60 * 60 * 24;
var mn = "month";
var wk = "week";
var dy = "day";
/**
 * Calculate date difference in whole days.
 */ var daysMath = function(ms) {
    var now = new Date();
    return Math.abs(Math.ceil((ms - now.getTime()) / day));
};
var getTimeAgoString = function(num, span) {
    return "".concat(num).concat(num > 2 && span === mn ? "+" : "", " ").concat(span).concat(num > 1 ? "s" : "", " ago");
};
/**
 * Format a date in days, weeks months ago.
 */ var formatDateAsAge = function(posted) {
    var now = new Date();
    var midnightMs = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();
    var postedDate = new Date(posted);
    var postedMs = new Date(postedDate.getFullYear(), postedDate.getMonth(), postedDate.getDate(), 0, 0, 0).getTime();
    switch(true){
        case postedMs < midnightMs - day * 90:
            return getTimeAgoString(3, mn);
        case postedMs < midnightMs - day * 60:
            return getTimeAgoString(2, mn);
        case postedMs < midnightMs - day * 28:
            return getTimeAgoString(1, mn);
        case postedMs < midnightMs - day * 21:
            return getTimeAgoString(3, wk);
        case postedMs < midnightMs - day * 14:
            return getTimeAgoString(2, wk);
        case postedMs < midnightMs - day * 7:
            return getTimeAgoString(1, wk);
        case postedMs < midnightMs - day:
            return getTimeAgoString(daysMath(postedMs), dy);
        case postedMs < midnightMs:
            return "Yesterday";
        default:
            return "Today";
    }
};


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Tooltip/Tooltip.tsx
var Tooltip = __webpack_require__(4636);
;// CONCATENATED MODULE: ./src/utils/strings.ts



/**
 * Convert a word to proper Case.
 */ var titleWordCase = function(txt) {
    return "".concat(txt.charAt(0).toUpperCase()).concat(txt.substr(1).toLowerCase());
};
/**
 * Regex for non-alphanumerics and spaces.
 */ var regex = /([~!@#$%^&*\]){}_+\-(\s])/ig;
/**
 * Convert a sentence to proper Case.
 */ var titleCase = function(txt) {
    return txt.split(regex).map(titleWordCase).join("");
};
/**
 * Convert number to string and add a comma for thousands and millions.
 */ var formatNumberComma = function(value) {
    var numberVal = parseInt(value, 10);
    return Number.isNaN(numberVal) ? value : new Intl.NumberFormat("en-US").format(numberVal);
};
var formatCompanySize = function(size) {
    var sizes = size === null || size === void 0 ? void 0 : size.split("_").map(function(companySize) {
        return formatNumberComma(companySize);
    });
    return sizes && sizes.length && sizes[1] === "plus" ? "".concat(sizes[0], "+") : sizes === null || sizes === void 0 ? void 0 : sizes.join(" - ");
};
var ref;
var getCompanyIndustries = function(industries) {
    return (ref = industries === null || industries === void 0 ? void 0 : industries.map(function(industry) {
        return industry.name;
    }).join(", ")) !== null && ref !== void 0 ? ref : "";
};
/**
 * generate the canonical URL.
 */ var getCanonicalUrl = function() {
    var asPath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/";
    var preface = "https://www.themuse.com";
    var path = asPath.split("?")[0];
    return preface + path;
};
var parsePath = function(urlPath) {
    return urlPath.replace(/^\/(search\/)?/, "").split("/").reduce(function(values, pathPart, index, shortenedPath) {
        var localValues = values;
        if (index % 2) {
            localValues[shortenedPath[index - 1]] = pathPart;
        } else {
            localValues[pathPart] = "";
        }
        return localValues;
    }, {});
};
/**
 *  Rename the object names to query param names
 */ var objToQueryParams = function(obj) {
    var mappedObj = Object.keys(obj).reduce(function(acc, key) {
        return _object_spread({}, acc, _define_property({}, key, encodeURIComponent(obj[key])));
    }, {});
    var queryParamStr = Object.keys(mappedObj).filter(function(key) {
        if (mappedObj[key] && mappedObj[key].length > 0) {
            return key;
        }
        return null;
    }).map(function(key) {
        return "".concat(key, "/").concat(mappedObj[key] || "");
    }).join("/");
    return queryParamStr;
};
/**
 * Convert the query string into an object
 */ var queryStringToObj = function(searchString) {
    var pairs = searchString.split("&");
    var result = {};
    pairs.forEach(function(pair) {
        var pairSplit = pair.split("=");
        if (pairSplit[0] in result) {
            // check for additional values and add it to the result[key]
            var splitValues = result[pairSplit[0]].split(",");
            splitValues.push(decodeURIComponent(pairSplit[1]));
            result[pairSplit[0]] = splitValues.join(",");
        } else {
            result[pairSplit[0]] = decodeURIComponent(pairSplit[1] || "");
        }
    });
    return result;
};
/**
 * Convert an object to query string removing nulls.
 */ var objToQueryString = function(obj) {
    return Object.keys(obj).map(function(key) {
        return "".concat(key, "=").concat(obj[key] || "");
    }).join("&");
};
/**
 * Convert a string to a slug.
 * * Decode URL encoded strings.
 * * Remove all white space with collapseWhiteSpace.
 * * Convert all diacritic to generics.
 * * Replace not alpha-numerics with dashes.
 * * Collapse all dashes to one dash.
 */ var slugify = function(text) {
    return decodeURIComponent(collapseWhiteSpace(text)).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/gmi, "-").replace(/-+/g, "-");
};
/**
 * Returns a slugified location name.
 * Use this for location instead of `slugify` as this normalizes
 * the location slug for remote-flexible
 * @param locationName string
 * @returns string
 */ var slugifyLocation = function(locationName) {
    if (locationName === "Flexible / Remote") {
        return "remote-flexible";
    }
    return slugify(locationName);
};
/**
 * Formats a date in correct format for job card
 */ var formatDate = function(date) {
    var month = months[date.getMonth()];
    var day = date.getDate();
    return "".concat(month, " ").concat(day);
};
/**
 * Returns a job apply redirect url
 */ var getApplyRedirectUrl = function(jobId) {
    return "/job/redirect/".concat(jobId);
};
var getCompanyLogo = function(companyLogo) {
    var urlRegex = /^((http|https):\/\/)/i;
    return (companyLogo === null || companyLogo === void 0 ? void 0 : companyLogo.length) > 10 && companyLogo.match(urlRegex) ? companyLogo : "";
};
/**
 * Return the display content for locations
 * content: The items to display in the tooltip
 */ var getLocations = function(locations) {
    var remoteString = "Flexible / Remote";
    var suffix = "Remote";
    var strLocations = locations.map(function(loc) {
        return loc.value;
    });
    var separator = " / ";
    var displaySuffix = strLocations.filter(function(value) {
        return value === remoteString;
    }).length;
    var nonRemoteLocations = strLocations.filter(function(value) {
        return value !== remoteString;
    }).slice(0, 37);
    var topLocation = nonRemoteLocations.shift();
    var dispLocation = "";
    if (displaySuffix) {
        dispLocation = suffix;
    }
    if (topLocation) {
        dispLocation = topLocation;
    }
    if (topLocation && displaySuffix) {
        dispLocation = "".concat(topLocation, " ").concat(separator, " ").concat(suffix);
    }
    var triggerText = "(+".concat(nonRemoteLocations.length, " more)");
    var result = nonRemoteLocations.length && {
        title: "locationsTip",
        triggerText: triggerText,
        content: nonRemoteLocations
    };
    return {
        dispLocation: dispLocation,
        tooltipProps: result
    };
};
var truncateStringWithEllipsis = function(targetString, truncateLength) {
    return targetString.length > truncateLength ? targetString.substr(0, truncateLength).concat("...") : targetString;
};
/**
 * Remove all contiguous whiteSpace,
 * * ' ' spaces.
 * * \n linefeed (LF or 0x0A (10) in ASCII).
 * * \r carriage return (CR or 0x0D (13) in ASCII).
 * * \t horizontal tab (HT or 0x09 (9) in ASCII).
 * * \v vertical tab (VT or 0x0B (11) in ASCII).
 * * \f form feed (FF or 0x0C (12) in ASCII).
 */ var collapseWhiteSpace = function(content) {
    return content.trim().replace(/[ \n\r\t\v\f]+/gm, " ");
}; // replace non-printing characters
/**
 * Returns true for "true", "True", "TRUE" and "1".
 * @param string string
 * @returns boolean
 */ var strings_isTruthy = function(string) {
    return /^(true|1)$/.test(string.toLowerCase());
};


// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/icons/IndustryIcon.tsx




/* eslint-disable max-len */ 
var IndustryIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "translate(-250.000000, -406.000000)",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        transform: "translate(228.000000, 232.000000)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            transform: "translate(20.000000, 143.000000)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                transform: "translate(0.000000, 29.000000)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    transform: "translate(2.000000, 2.000000)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M17.3555556,4.16666667 L3.75555556,4.16666667 C3.30468581,4.16666667 2.87228656,4.36419792 2.55347281,4.71585417 C2.23466331,5.06746354 2.05555556,5.54436979 2.05555556,6.04166667 L2.05555556,17.2916667 C2.05555556,17.7889635 2.23466331,18.2658698 2.55347281,18.6174792 C2.87228656,18.9691354 3.30468581,19.1666667 3.75555556,19.1666667 L17.3555556,19.1666667 C17.8064381,19.1666667 18.2388331,18.9691354 18.5576256,18.6174792 C18.8764606,18.2658698 19.0555556,17.7889635 19.0555556,17.2916667 L19.0555556,6.04166667 C19.0555556,5.54436979 18.8764606,5.06746354 18.5576256,4.71585417 C18.2388331,4.36419792 17.8064381,4.16666667 17.3555556,4.16666667 L17.3555556,4.16666667 Z M13.1055556,9.66510417 C13.1055556,10.0256198 12.9757181,10.3714167 12.7445606,10.6263229 C12.5134456,10.881276 12.1999231,11.0244792 11.8730556,11.0244792 L9.23805556,11.0244792 C8.91118806,11.0244792 8.59766556,10.881276 8.36655056,10.6263229 C8.13539306,10.3714167 8.00555556,10.0256198 8.00555556,9.66510417 L8.00555556,8.63385417 C8.00555556,8.27333854 8.13539306,7.92754167 8.36655056,7.67263542 C8.59766556,7.41768229 8.91118806,7.27447917 9.23805556,7.27447917 L11.8730556,7.27447917 C12.1999231,7.27447917 12.5134456,7.41768229 12.7445606,7.67263542 C12.9757181,7.92754167 13.1055556,8.27333854 13.1055556,8.63385417 L13.1055556,9.66510417 Z",
                                            fill: "#D8D8D8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M16.9397517,4.46987952 L12.9277075,4.46987952 L12.9277075,2.62650602 C12.9254521,2.19583325 12.7533462,1.78344675 12.4487778,1.47890843 C12.1442528,1.17437446 11.7318581,1.00227711 11.3012031,1 L8.69879602,1 C8.26814102,1.00227711 7.85574625,1.17437446 7.55122125,1.47890843 C7.24665288,1.78344675 7.0745904,2.19583325 7.07229161,2.62650602 L7.07229161,4.46554217 L3.06024741,4.46554217 C2.78932816,4.46554217 2.52106771,4.51897831 2.27082458,4.62277108 C2.02058146,4.72660723 1.79326988,4.87871807 1.60190621,5.07051566 C1.41053821,5.26226988 1.25886993,5.48989398 1.15558906,5.7403759 C1.0523082,5.99081446 0.999440304,6.25920964 1.00000396,6.53012048 L1.00000396,16.939759 C1.00000396,17.4861783 1.21707093,18.0102169 1.60344163,18.396588 C1.98980799,18.782959 2.51383735,19 3.06024741,19 L16.9397517,19 C17.4861704,19 18.0102084,18.782959 18.3965791,18.396588 C18.7829498,18.0102169 18.9999906,17.4861783 18.9999906,16.939759 L18.9999906,6.53012048 C18.9999906,5.9837012 18.7829498,5.45966265 18.3965791,5.07329157 C18.0102084,4.68692048 17.4861704,4.46987952 16.9397517,4.46987952 L16.9397517,4.46987952 Z M7.72289337,2.62650602 C7.72402108,2.36803036 7.82720652,2.12046747 8.00998224,1.93770024 C8.19275797,1.75492867 8.44033362,1.65174313 8.69879602,1.65060241 L11.3012031,1.65060241 C11.5596655,1.65174313 11.8072411,1.75492867 11.9900168,1.93770024 C12.1727926,2.12046747 12.275978,2.36803036 12.2771057,2.62650602 L12.2771057,4.46554217 L7.72289337,4.46554217 L7.72289337,2.62650602 Z M3.06024741,5.12048193 L16.9397517,5.12048193 C17.3132405,5.12160964 17.6711582,5.27051084 17.9352591,5.53461205 C18.1993601,5.79871325 18.3482611,6.15663133 18.3493888,6.53012048 L18.3493888,9.21060241 L12.9277075,9.21060241 L12.9277075,8.9286747 C12.9265798,8.50916627 12.7594185,8.10713735 12.4627441,7.81050602 C12.166113,7.51383133 11.7640845,7.34666988 11.3445765,7.34554217 L8.65542256,7.34554217 C8.23591455,7.34666988 7.83388603,7.51383133 7.537255,7.81050602 C7.2405806,8.10713735 7.07341932,8.50916627 7.07229161,8.9286747 L7.07229161,9.21060241 L1.65061026,9.21060241 L1.65061026,6.53012048 C1.65175532,6.15663133 1.80063902,5.79871325 2.06474864,5.53461205 C2.32885826,5.27051084 2.68674128,5.12160964 3.06024741,5.12048193 L3.06024741,5.12048193 Z M12.2771057,8.9286747 L12.2771057,9.88289157 C12.275978,10.1298602 12.1773468,10.3663759 12.0027253,10.541041 C11.8280604,10.7156627 11.5915449,10.814294 11.3445765,10.8154217 L8.65542256,10.8154217 C8.40845414,10.814294 8.17193871,10.7156627 7.99727382,10.541041 C7.82265231,10.3663759 7.72402108,10.1298602 7.72289337,9.88289157 L7.72289337,8.9286747 C7.72289337,8.68135904 7.82113424,8.4441494 7.99601599,8.26926747 C8.17089775,8.09438554 8.40810715,7.99614458 8.65542256,7.99614458 L11.3445765,7.99614458 C11.5918919,7.99614458 11.8291013,8.09438554 12.0039831,8.26926747 C12.1788648,8.4441494 12.2771057,8.68135904 12.2771057,8.9286747 L12.2771057,8.9286747 Z M16.9397517,18.3493976 L3.06024741,18.3493976 C2.68674128,18.3482699 2.32885826,18.1993687 2.06474864,17.9352675 C1.80063902,17.6711663 1.65175532,17.3132482 1.65061026,16.939759 L1.65061026,9.86120482 L7.07229161,9.86120482 L7.07229161,9.88289157 C7.07341932,10.3024 7.2405806,10.7044289 7.537255,11.0010602 C7.83388603,11.2977349 8.23591455,11.4648964 8.65542256,11.4660241 L11.3445765,11.4660241 C11.7640845,11.4648964 12.166113,11.2977349 12.4627441,11.0010602 C12.7594185,10.7044289 12.9265798,10.3024 12.9277075,9.88289157 L12.9277075,9.86120482 L18.3493888,9.86120482 L18.3493888,16.939759 C18.3482611,17.3132482 18.1993601,17.6711663 17.9352591,17.9352675 C17.6711582,18.1993687 17.3132405,18.3482699 16.9397517,18.3493976 L16.9397517,18.3493976 Z",
                                            fill: "#666666"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/SizeIcon.tsx




/* eslint-disable max-len */ 
var SizeIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "translate(-250.000000, -377.000000)",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        transform: "translate(228.000000, 232.000000)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            transform: "translate(20.000000, 143.000000)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                transform: "translate(2.000000, 2.000000)",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M14.1298213,7.81811542 C14.9860301,7.329114 15.6416275,6.54476184 15.9779398,5.60709493 C16.3142521,4.66942802 16.308984,3.64043177 15.9631703,2.70633488 C15.6173565,1.7722571 14.95381,0.994849024 14.0926623,0.51485628 C13.2314675,0.0348635361 12.2296331,-0.115989961 11.2684854,0.0896037849 C10.3073377,0.29520231 9.45037629,0.843656208 8.8528222,1.63567888 C8.25522107,2.42770634 7.95649106,3.41093756 8.01067733,4.40743566 C8.06486359,5.40388597 8.46839135,6.34771797 9.14821261,7.06802968 C9.82803387,7.7882936 10.7392286,8.23753259 11.7168391,8.33426234 L12.5258702,8.33426234 C13.4159454,8.33550492 14.2970837,8.51491377 15.1189558,8.86216595 C15.9408278,9.20941813 16.6873471,9.71772727 17.3158984,10.358084 C17.9444026,10.9984885 18.4426152,11.7583715 18.7821261,12.5943861 C19.1215898,13.4304008 19.2956726,14.3262024 19.2944497,15.2305588 C19.2944497,15.2445138 19.2889934,15.2578954 19.2793039,15.2677404 C19.2696143,15.2775855 19.256444,15.2831293 19.2427093,15.2831293 L5,15.2831293 L5,16 L19.2427093,16 C19.443556,16 19.6361712,15.9189458 19.778175,15.7746636 C19.9202258,15.6303337 20,15.434628 20,15.2305588 C19.9972248,13.5008931 19.414111,11.8238457 18.3468956,10.4762243 C17.2796802,9.12865069 15.7921449,8.19103157 14.1298213,7.81811542 L14.1298213,7.81811542 Z M8.71119473,4.17163298 C8.71119473,3.48635236 8.91119473,2.816451 9.28588899,2.24665347 C9.66063029,1.67686072 10.1932267,1.2327593 10.8163217,0.970508873 C11.4394638,0.708263223 12.1251176,0.639644357 12.7866416,0.773335969 C13.4481656,0.90703236 14.0557855,1.23702707 14.5326905,1.72159823 C15.0096425,2.20616939 15.3344309,2.8235528 15.4659925,3.49567168 C15.5975541,4.16780967 15.5300564,4.86446465 15.2719191,5.49760487 C15.0138288,6.13069731 14.5767168,6.67183913 14.0159454,7.05259307 C13.455127,7.43329921 12.7958137,7.63650817 12.1213547,7.63650817 C11.2173095,7.63526559 10.3506585,7.2698049 9.71138288,6.62027222 C9.07210724,5.97073955 8.71241769,5.09018334 8.71119473,4.17163298 L8.71119473,4.17163298 Z",
                                        fill: "#666666"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M7.57,12 L8.43,12 C10.4377,12 12.36315,12.6978562 13.7828,13.94005 C15.20245,15.1822437 16,16.8670125 16,18.62375 C16,18.7235437 15.9547,18.819225 15.87405,18.8897938 C15.7934,18.9603625 15.68405,19 15.57,19 L0.43,19 C0.315955,19 0.206585,18.9603625 0.125945,18.8897938 C0.045305,18.819225 0,18.7235437 0,18.62375 C0,16.8670125 0.79755,15.1822437 2.2172,13.94005 C3.63685,12.6978562 5.5623,12 7.57,12 L7.57,12 Z",
                                        fill: "#D8D8D8"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M8,12 C10.20915,12 12,10.20915 12,8 C12,5.79085 10.20915,4 8,4 C5.79085,4 4,5.79085 4,8 C4,10.20915 5.79085,12 8,12 Z",
                                        fill: "#D8D8D8"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M10.039403,11.8250894 C10.8467104,11.3738458 11.4814567,10.667566 11.8442507,9.81698371 C12.206997,8.96640145 12.2773015,8.01950614 12.0440836,7.12465903 C11.8108657,6.22985967 11.2873075,5.43767645 10.5555104,4.8722133 C9.82366567,4.30675015 8.92489552,4 8,4 C7.07510448,4 6.17633433,4.30675015 5.44448955,4.8722133 C4.71269254,5.43767645 4.18913433,6.22985967 3.95591642,7.12465903 C3.72269851,8.01950614 3.79300299,8.96640145 4.15574925,9.81698371 C4.51854328,10.667566 5.15328955,11.3738458 5.96059701,11.8250894 C4.27266866,12.1976877 2.76220657,13.1345076 1.67855284,14.4809326 C0.594903881,15.8274053 0.00281313433,17.5030232 0,19.2312146 C0,19.4351099 0.0810125373,19.6306488 0.225222687,19.774808 C0.296625672,19.8461952 0.381397015,19.9028274 0.474688955,19.9414577 C0.567980896,19.9801357 0.667973731,20 0.768955224,20 L15.2310448,20 C15.4349851,20 15.6305672,19.9190149 15.7747582,19.774808 C15.918997,19.6306488 16,19.4351099 16,19.2312146 C15.9971821,17.5030232 15.4050866,15.8274053 14.3214328,14.4809326 C13.2377791,13.1345076 11.7273313,12.1976877 10.039403,11.8250894 L10.039403,11.8250894 Z M4.53731343,8.18171508 C4.53731343,7.49701857 4.74039403,6.82769776 5.1208597,6.25836681 C5.50137313,5.68908361 6.04217313,5.24533685 6.67486567,4.98332906 C7.30760597,4.72127351 8.0038209,4.65275133 8.67553433,4.78630989 C9.34724776,4.91986845 9.96422687,5.24958666 10.4484776,5.73377821 C10.9327761,6.21792201 11.2625672,6.83476486 11.3961552,7.50632995 C11.5297433,8.17789503 11.461206,8.8739562 11.1990925,9.50655676 C10.9370269,10.1391096 10.4931821,10.6797901 9.92377313,11.0602195 C9.35431642,11.4406012 8.68484776,11.6436369 8,11.6436369 C7.08202985,11.6423954 6.20202985,11.2772462 5.55290746,10.6282672 C4.90378507,9.97928816 4.53855522,9.0994825 4.53731343,8.18171508 L4.53731343,8.18171508 Z M15.2310448,19.2837403 L0.768955224,19.2837403 C0.755023284,19.2837403 0.741659701,19.2782012 0.731806567,19.2683646 C0.721953433,19.2584802 0.71641791,19.2451578 0.71641791,19.2312146 C0.718944478,17.4096229 1.44385433,15.6633341 2.73221731,14.3752604 C4.02058507,13.0871867 5.7672597,12.3624274 7.58925373,12.3598966 L8.41074627,12.3598966 C10.2327403,12.3624274 11.9794149,13.0871867 13.2677731,14.3752604 C14.5561313,15.6633341 15.2810507,17.4096229 15.2835821,19.2312146 C15.2835821,19.2451578 15.2780418,19.2584802 15.268203,19.2683646 C15.2583642,19.2782012 15.244991,19.2837403 15.2310448,19.2837403 Z",
                                        fill: "#666666"
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    }));
};


// EXTERNAL MODULE: ./src/components/CompanyInformationModule.module.scss
var CompanyInformationModule_module = __webpack_require__(1530);
var CompanyInformationModule_module_default = /*#__PURE__*/__webpack_require__.n(CompanyInformationModule_module);
;// CONCATENATED MODULE: ./src/components/CompanyInformationModule.tsx


/* eslint-disable react/jsx-no-target-blank */ 







var customLinkClickedTracking = function(event, trackingProps) {
    (0,tracking/* museTrack */.YU)("Jobs Individual Link Clicked", (0,src_object_spread/* default */.Z)({}, trackingProps, {
        link: event.currentTarget.href
    }));
};
var getPilboxUrl = function(imageUrl, imageWidth) {
    var pilboxUrl = "https://pilbox.themuse.com/";
    var imageUrlRegex = /^https?:\/\//;
    if (imageUrlRegex.test(imageUrl)) {
        return "".concat(pilboxUrl, "?url=").concat(imageUrl, "&w=").concat(imageWidth, "&filter=antialias&opt=1&pos=center&prog=1&q=keep");
    }
    return "";
};
/**
 * Generates the company logo
 */ var CompanyLogo = function(props) {
    var _url = props.url, url = _url === void 0 ? "" : _url, _name = props.name, name = _name === void 0 ? "" : _name;
    return url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* CompanyLogoOutlined */.uC, {
        className: (CompanyInformationModule_module_default()).companyLogo,
        logoUrl: url,
        altText: "".concat(name, " Logo")
    }) : null;
};
/**
 * Generates Heading
 */ var CompanyHeading = function(props) {
    var _desc = props.desc, desc = _desc === void 0 ? "" : _desc;
    return desc.length > 10 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "About Us"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (CompanyInformationModule_module_default()).companyShortDescription,
                children: desc
            })
        ]
    }) : null;
};
/**
 * Generates the range list items
 */ var CompanyRange = function(props) {
    var _range = props.range, range = _range === void 0 ? [] : _range, _size = props.size, size = _size === void 0 ? "" : _size;
    return range ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Size:"
            }),
            " ",
            "".concat(size, " employees")
        ]
    }) : null;
};
/**
 * Generates the industries list items
 */ var CompanyIndustries = function(props) {
    var _industries = props.industries, industries = _industries === void 0 ? [] : _industries, _companyIndustries = props.companyIndustries, companyIndustries = _companyIndustries === void 0 ? "" : _companyIndustries;
    return industries.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustryIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Industry:"
            }),
            " ",
            companyIndustries
        ]
    }) : null;
};
/**
 * Generates the photo in the body of the module
 */ var CompanySnapshot = function(props) {
    var _companyName = props.companyName, companyName = _companyName === void 0 ? "" : _companyName, _src = props.src, src = _src === void 0 ? "" : _src, _mobile = props.mobile, mobile = _mobile === void 0 ? false : _mobile;
    var loading = mobile ? "lazy" : "eager";
    return src ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        alt: companyName,
        loading: loading,
        src: src,
        height: "167",
        width: "250"
    }) : null;
};
/**
 * Generates the Link at the bottom of the module
 */ var CompanyProfileLink = function(props) {
    var companyName = props.companyName, tracking = props.tracking;
    var companyProfileLinkClickedTrackingProps = (0,src_object_spread/* default */.Z)({}, tracking, {
        click_origin: "company_info_module",
        new_tab: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: (CompanyInformationModule_module_default()).companyProfileLink,
        onClick: function(event) {
            return customLinkClickedTracking(event, companyProfileLinkClickedTrackingProps);
        },
        href: "/profiles/".concat(companyName),
        target: "_blank",
        children: [
            "View Company Profile",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* ArrowRightShape */.q9, {})
        ]
    });
};
var CompanyInformationModule = function(props) {
    var company = props.company, job = props.job, _displayOnMobile = props.displayOnMobile, displayOnMobile = _displayOnMobile === void 0 ? false : _displayOnMobile;
    var companySize = formatCompanySize(company === null || company === void 0 ? void 0 : company.employee_range);
    var companyIndustries = getCompanyIndustries(company === null || company === void 0 ? void 0 : company.industries);
    var companyLogo = getCompanyLogo(company === null || company === void 0 ? void 0 : company.logo) || "";
    var jobTrackingProps = (0,tracking/* getJobTrackingProps */.Cg)(job, company);
    var snapshotPhotoSrc = getPilboxUrl(company === null || company === void 0 ? void 0 : company.snapshot_photo, 500);
    var display = displayOnMobile ? "mobile" : "desktop";
    var containerClasses = classnames_default()(snapshotPhotoSrc ? "".concat((CompanyInformationModule_module_default()).companyInformationModule, " ").concat((CompanyInformationModule_module_default()).hasPhoto, " ").concat((CompanyInformationModule_module_default())[display]) : "".concat((CompanyInformationModule_module_default()).companyInformationModule, " ").concat((CompanyInformationModule_module_default())[display]));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: containerClasses,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogo, {
                url: companyLogo,
                name: company === null || company === void 0 ? void 0 : company.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyHeading, {
                desc: company.short_description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyRange, {
                        range: company.employee_range,
                        size: companySize
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyIndustries, {
                        industries: company.industries,
                        companyIndustries: companyIndustries
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySnapshot, {
                companyName: company.name,
                src: snapshotPhotoSrc,
                mobile: displayOnMobile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyProfileLink, {
                companyName: company.short_name,
                tracking: jobTrackingProps
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/JobIndividualHeader.module.scss
var JobIndividualHeader_module = __webpack_require__(5870);
var JobIndividualHeader_module_default = /*#__PURE__*/__webpack_require__.n(JobIndividualHeader_module);
;// CONCATENATED MODULE: ./src/components/JobIndividualHeader.tsx


/* eslint-disable react/jsx-no-target-blank */ 







var JobIndividualHeader_customLinkClickedTracking = function(event, trackingProps) {
    (0,tracking/* museTrack */.YU)("Jobs Individual Link Clicked", (0,src_object_spread/* default */.Z)({}, trackingProps, {
        link: event.currentTarget.href
    }));
};
var JobIndividualHeader = function() {
    var ref = (0,AppContext/* useAppState */.mr)(), job = ref.job, company = ref.company;
    var jobName = job.name, postedDate = job.posted_at, locations = job.locations;
    var ref1 = getLocations(locations), dispLocation = ref1.dispLocation, tooltipProps = ref1.tooltipProps;
    var jobTrackingProps = (0,tracking/* getJobTrackingProps */.Cg)(job, company);
    var companyNameClickedTrackingProps = (0,src_object_spread/* default */.Z)({}, jobTrackingProps, {
        click_origin: "company_name",
        new_tab: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (JobIndividualHeader_module_default()).jobHeaderContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/profiles/".concat(company === null || company === void 0 ? void 0 : company.short_name),
                className: (JobIndividualHeader_module_default()).jobHeaderCompanyName,
                onClick: function(event) {
                    return JobIndividualHeader_customLinkClickedTracking(event, companyNameClickedTrackingProps);
                },
                target: "_blank",
                children: company === null || company === void 0 ? void 0 : company.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (JobIndividualHeader_module_default()).jobHeaderTitle,
                children: jobName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (JobIndividualHeader_module_default()).jobHeaderSubHeading,
                children: [
                    formatDateAsAge(postedDate),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (JobIndividualHeader_module_default()).jobHeaderSeparator,
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (JobIndividualHeader_module_default()).jobHeaderLocation,
                        children: dispLocation
                    }),
                    locations.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,src_object_spread/* default */.Z)({}, tooltipProps)) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInformationModule, {
                company: company,
                job: job,
                displayOnMobile: false
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// EXTERNAL MODULE: ./src/utils/appcast.ts
var appcast = __webpack_require__(5425);
;// CONCATENATED MODULE: ./src/utils/cookies.ts
// These only work inside the browser

/**
 * Retrieve an existing cookie or an empty string.
 */ var get = function(name) {
    var r = document.cookie.match("\\b".concat(name, "=([^;]*)\\b"));
    return r ? r[1] : "";
};
/**
 * Set a cookie or replace an existing cookie.
 */ var set = function(name, value) {
    var days = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!(0,browser/* isBrowser */.jU)()) {
        return "";
    }
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=".concat(date.toUTCString());
    }
    document.cookie = "".concat(name, "=").concat(value, ";expires=").concat(expires, ";path=/");
    return document.cookie;
};
/**
 * Delete an existing cookie. (named remove due to delete being a reserved word)
 */ var remove = function(name) {
    set(name, "", -1);
};
var Cookies = {
    remove: remove,
    get: get,
    set: set
};
/* harmony default export */ var cookies = (Cookies);

;// CONCATENATED MODULE: ./src/utils/externalJobApply.ts


var cookieKey = "external_job_ids_list";
/**
 * Retrieve and decode the job object from the cookie.
 */ var getJobObject = function() {
    var cookie = cookies.get(cookieKey);
    var decodedData = window.atob(cookie.toString());
    var jobObject = JSON.parse(decodedData || "{}");
    return jobObject;
};
/**
 * Inject a new job ID and dedupe the list.
 */ var updateJobList = function(list, id) {
    list.push(id);
    var newList = list.filter(function(x, index) {
        return list.indexOf(x) === index;
    });
    return newList;
};
/**
 * Creat or update the jobs object.
 */ var setJobObject = function(companyId, jobId) {
    var jobObject = getJobObject();
    jobObject[companyId] = jobObject[companyId] ? updateJobList(jobObject[companyId], jobId) : [
        jobId
    ];
    var encryptedJobs = window.btoa(JSON.stringify(jobObject));
    return encryptedJobs;
};
/**
 * Sets a cookie with the encrypted companies and jobs applied to by this session within the last 30 days.
 */ var externalJobApply = function(companyId, jobId) {
    if (!(0,browser/* isBrowser */.jU)()) {
        return;
    }
    var jobObject = setJobObject(companyId, jobId);
    cookies.set(cookieKey, jobObject, 30);
};


;// CONCATENATED MODULE: ./src/components/JobApplyButton.tsx











var JobApplyButton = function(props) {
    var className = props.className, jobId = props.jobId, trackingProps = props.trackingProps, setIsOpen = props.setIsOpen, isDirectApply = props.isDirectApply;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(getApplyRedirectUrl(jobId)), 2), redirectUrl = ref[0], setRedirectUrl = ref[1];
    var buttonText = isDirectApply ? "Quick Apply" : "Apply on company site";
    var targetPageSection = isDirectApply ? "direct_apply_form" : "off_site";
    var trackingClass = "track-job-apply-button";
    var snowplowTrackingProps = {
        sp_click_button_text: buttonText,
        sp_click_button_type: "apply",
        sp_click_component: "button",
        sp_click_position: (trackingProps === null || trackingProps === void 0 ? void 0 : trackingProps.placement_position) === "right_rail" ? "right_rail" : "bottom",
        sp_click_target_page_section: targetPageSection
    };
    var linkHandler = function() {
        externalJobApply(trackingProps.company_id, jobId);
        (0,tracking/* museTrack */.YU)("Job Apply Clicked", trackingProps);
        (0,appcast/* appCastJobApply */.N)();
    };
    var modalHandler = function() {
        setIsOpen === null || setIsOpen === void 0 ? void 0 : setIsOpen(true);
        linkHandler();
    };
    var btnProps = {
        className: "".concat(className, " ").concat(trackingClass),
        href: isDirectApply ? null : redirectUrl,
        target: isDirectApply ? null : "_blank",
        onClick: isDirectApply ? modalHandler : linkHandler,
        color: "secondary-100",
        "data-tracking-event-type": "click",
        "data-tracking-props": JSON.stringify(snowplowTrackingProps)
    };
    var cleanProps = Object.keys(btnProps).filter(function(k) {
        return !!btnProps[k];
    }).reduce(function(a, k) {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, a), (0,src_define_property/* default */.Z)({}, k, btnProps[k]));
    }, {});
    react.useEffect(function() {
        setRedirectUrl("".concat(redirectUrl).concat(window.location.search));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SquareButton */.LE, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cleanProps), {
        children: buttonText
    }));
};

// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/components/JobIndividualBody.module.scss
var JobIndividualBody_module = __webpack_require__(6766);
var JobIndividualBody_module_default = /*#__PURE__*/__webpack_require__.n(JobIndividualBody_module);
;// CONCATENATED MODULE: ./src/components/JWPlayerVideoModule.tsx






var installPlayerScript = function(param) {
    var onLoadCallback = param.onLoadCallback, scriptSrc = param.scriptSrc, uniqueScriptId = param.uniqueScriptId;
    var jwPlayerScript = document.createElement("script");
    jwPlayerScript.id = uniqueScriptId;
    jwPlayerScript.src = scriptSrc;
    jwPlayerScript.defer = true;
    jwPlayerScript.onload = onLoadCallback;
    document.head.appendChild(jwPlayerScript);
};
var JWPlayerVideoModule = function(props) {
    var title = props.title, description = props.description, tagName = props.tagName;
    var playerRef = (0,react.useRef)();
    var playerWrapperRef = (0,react.useRef)();
    var dataTrackingProps = {
        sp_impression_component: "insert",
        sp_impression_insert_type: "media",
        sp_impression_position: "bottom",
        sp_search_id: "null",
        sp_media_type: "video",
        sp_media_id: null,
        sp_media_name: null,
        sp_media_provider_key: null,
        sp_media_provider_name: "jwplayer"
    };
    var ref = (0,react.useState)(false), playerScriptInitialized = ref[0], setPlayerScriptInitialized = ref[1];
    var ref1 = (0,react.useState)(null), jwplayerInstance = ref1[0], setJwplayerInstance = ref1[1];
    var ref2 = (0,react.useState)(null), trackingProps = ref2[0], setTrackingProps = ref2[1];
    var ref3 = (0,react.useState)(false), firstView = ref3[0], setFirstView = ref3[1];
    (0,react.useEffect)(function() {
        installPlayerScript({
            onLoadCallback: function() {
                setPlayerScriptInitialized(true);
            },
            scriptSrc: "https://cdn.jwplayer.com/libraries/OOgy074L.js",
            uniqueScriptId: "jdp-jwplayer-instance"
        });
    }, []);
    (0,react.useEffect)(function() {
        if (playerScriptInitialized) {
            var instance = window.jwplayer(playerRef.current).setup({
                playlist: "https://cdn.jwplayer.com/v2/playlists/5lLe5BiO?tags=".concat(tagName),
                mute: true
            });
            setJwplayerInstance(instance);
        }
    }, [
        playerScriptInitialized
    ]);
    (0,react.useEffect)(function() {
        if (jwplayerInstance !== null) {
            jwplayerInstance.on("ready", function() {
                var playlist = jwplayerInstance.getPlaylist();
                setTrackingProps((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dataTrackingProps), {
                    sp_media_id: playlist[0].mediaid,
                    sp_media_name: playlist[0].title,
                    sp_media_provider_key: "".concat(playlist[0].feedid, "-").concat(tagName)
                }));
            });
        }
    }, [
        jwplayerInstance
    ]);
    (0,react.useEffect)(function() {
        if (jwplayerInstance && trackingProps) {
            jwplayerInstance.on("viewable", function() {
                // The viewable event is bugged, so we add a getViewable check
                if (!firstView && jwplayerInstance.getViewable()) {
                    (0,build/* triggerSnowplowImpressionEvent */.XQ)(playerWrapperRef.current);
                    setFirstView(true);
                }
            });
            jwplayerInstance.on("play", function() {
                (0,build/* triggerSnowplowVideoEvent */.GF)("play", playerWrapperRef.current);
            });
        }
    }, [
        jwplayerInstance,
        trackingProps
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobIndividualBody_module_default()).jobBodyJWPlayerVideo,
        ref: playerWrapperRef,
        "data-tracking-props": JSON.stringify(trackingProps),
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: title
            }) : null,
            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: playerRef
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/HealthAndWellnessIcon.tsx




/* eslint-disable max-len */ 
var HealthAndWellnessIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 20 20",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.94,6a1.1,1.1,0,0,0-.32-.78,1.14,1.14,0,0,0-.78-.32H11.53V1.6a1.14,1.14,0,0,0-.32-.78A1.14,1.14,0,0,0,10.43.5H6a1.14,1.14,0,0,0-.78.32,1.14,1.14,0,0,0-.32.78V4.91H1.6a1.14,1.14,0,0,0-.78.32A1.14,1.14,0,0,0,.5,6v4.42a1.14,1.14,0,0,0,.32.78,1.14,1.14,0,0,0,.78.32H4.91v3.31a1.14,1.14,0,0,0,.32.78,1.1,1.1,0,0,0,.78.32h4.42a1.1,1.1,0,0,0,.78-.32,1.14,1.14,0,0,0,.32-.78V11.53h3.31a1.14,1.14,0,0,0,.78-.32,1.1,1.1,0,0,0,.32-.78Z",
                fill: "#d8f0e9",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/FinanceIcon.tsx




/* eslint-disable max-len */ 
var FinanceIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 20 17.3",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.68,12.09a5.67,5.67,0,0,0,1.67-1.94A5.8,5.8,0,0,0,16,7.67C16,4.32,12.72,1.6,8.7,1.6a8.44,8.44,0,0,0-2.35.33A4,4,0,0,0,4.52.53a.4.4,0,0,0-.24,0,.53.53,0,0,0-.22.08A.55.55,0,0,0,3.9.77a.59.59,0,0,0,0,.23V3.17A5.33,5.33,0,0,0,2,5.56H1a.5.5,0,0,0-.51.5v3a.47.47,0,0,0,.15.35A.48.48,0,0,0,1,9.6H2a5.93,5.93,0,0,0,2,2.72L3.43,14a1.23,1.23,0,0,0,0,1,1.55,1.55,0,0,0,.28.39,1.33,1.33,0,0,0,.41.25,1.15,1.15,0,0,0,.48.07,1.12,1.12,0,0,0,.47-.11,1.33,1.33,0,0,0,.38-.29,1.18,1.18,0,0,0,.24-.42l.56-1.5a8.52,8.52,0,0,0,5.26-.11l.59,1.61a1.27,1.27,0,0,0,.25.42,1.2,1.2,0,0,0,.38.29,1.31,1.31,0,0,0,.47.12,1.09,1.09,0,0,0,.47-.08,1,1,0,0,0,.41-.25,1.08,1.08,0,0,0,.28-.39,1.12,1.12,0,0,0,.11-.47,1.36,1.36,0,0,0-.09-.48Z",
                fill: "#d8f0e9",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.38,5.8A4.7,4.7,0,0,0,9.31,4.24",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16,7.67c1.62,0,2.43-.81,2.43-2",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.42,5.38a1,1,0,0,1,1,.64,1,1,0,0,1,.06.6,1.08,1.08,0,0,1-.28.54,1.06,1.06,0,0,1-.54.29A1.12,1.12,0,0,1,5,7.39,1.06,1.06,0,0,1,4.55,7a1,1,0,0,1-.18-.58,1,1,0,0,1,.31-.74A1.05,1.05,0,0,1,5.42,5.38Z",
                fill: "#666"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/OfficeLifeIcon.tsx




/* eslint-disable max-len */ 
var OfficeLifeIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 20 21.76",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.11,9.58h1.12a2,2,0,0,1,1.58.88,3.7,3.7,0,0,1,0,4.22,2,2,0,0,1-1.58.87H13.07",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M.86,7.21h12a.36.36,0,0,1,.36.36V16a2.24,2.24,0,0,1-2.24,2.24H2.74A2.24,2.24,0,0,1,.5,16V7.57A.36.36,0,0,1,.86,7.21Z",
                fill: "#d8f0e9",
                stroke: "#666"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.33.5l.94.79a.76.76,0,0,1,.22.28.8.8,0,0,1,.07.34.84.84,0,0,1-.07.35.85.85,0,0,1-.22.28l-.94.79A.77.77,0,0,0,8,4a.84.84,0,0,0,.07.35.85.85,0,0,0,.22.28l.58.49",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.76.5l.94.79a.76.76,0,0,1,.22.28A.8.8,0,0,1,6,1.91a.84.84,0,0,1-.07.35.85.85,0,0,1-.22.28l-.94.79a.76.76,0,0,0-.22.28A.77.77,0,0,0,4.46,4a.82.82,0,0,0,.3.63l.58.49",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/ProfessionalDevelopmentIcon.tsx




/* eslint-disable max-len */ 
var ProfessionalDevelopmentIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 20 18.38",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.62,15.11V2.55S6.84.58.87.5a.35.35,0,0,0-.14,0A.32.32,0,0,0,.61.61.36.36,0,0,0,.5.87V12.69A.42.42,0,0,0,.6,13a.36.36,0,0,0,.26.11C6.84,13.14,8.62,15.11,8.62,15.11Z",
                fill: "#d8f0e9",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.62,15.11V2.55s1.77-2,7.74-2a.35.35,0,0,1,.14,0,.25.25,0,0,1,.12.08.36.36,0,0,1,.11.26V12.69a.42.42,0,0,1-.1.26.36.36,0,0,1-.26.11C10.39,13.14,8.62,15.11,8.62,15.11Z",
                fill: "#d8f0e9",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.69,4a.5.5,0,0,0-.07,1,14.86,14.86,0,0,1,3.67.74.52.52,0,0,0,.64-.32.51.51,0,0,0-.32-.63A15.86,15.86,0,0,0,2.69,4Zm0,4a.5.5,0,0,0-.07,1,14.84,14.84,0,0,1,3.67.73.51.51,0,0,0,.64-.31.52.52,0,0,0-.32-.64A15.85,15.85,0,0,0,2.69,8ZM15.07,4.42a.5.5,0,0,1-.46.53,14.86,14.86,0,0,0-3.67.74.5.5,0,0,1-.63-.32.5.5,0,0,1,.31-.63A15.86,15.86,0,0,1,14.54,4,.5.5,0,0,1,15.07,4.42ZM14.61,9a.5.5,0,0,0-.07-1,15.85,15.85,0,0,0-3.92.78.51.51,0,0,0-.31.64.49.49,0,0,0,.63.31A14.84,14.84,0,0,1,14.61,9Z",
                fill: "#666",
                fillRule: "evenodd"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/VacationAndTimeOffIcon.tsx




/* eslint-disable max-len */ 
var VacationAndTimeOffIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 20 18.03",
        fill: "none",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.15,6.46a1,1,0,0,0,.36-.23,1,1,0,0,0,.21-.37.9.9,0,0,0,0-.43A.88.88,0,0,0,17.56,5,9.07,9.07,0,0,0,1.4,10.66a.87.87,0,0,0,.1.42.79.79,0,0,0,.28.32.83.83,0,0,0,.4.16.75.75,0,0,0,.42,0Z",
                fill: "#d8f0e9",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.94.5l.44,1.21",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.43,13.57l-1-2.84L10,9.32",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M.5,16.6a4.44,4.44,0,0,0,2-.19,4.43,4.43,0,0,0,1.67-1,3.66,3.66,0,0,0,1.23.9,3.82,3.82,0,0,0,1.49.31,3.74,3.74,0,0,0,1.48-.31,3.66,3.66,0,0,0,1.23-.9,3.87,3.87,0,0,0,1.23.9,3.74,3.74,0,0,0,3,0,3.76,3.76,0,0,0,1.23-.9,4.38,4.38,0,0,0,3.62,1.21",
                fill: "none",
                stroke: "#666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/DiversityAndInclusionIcon.tsx




/* eslint-disable max-len */ 
var DiversityAndInclusionIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 36 36",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.925 4.27h4.797v6.927h-4.364l-1.062.59-2.83 2.508H4.86l-.667-.905-.316-1.69c-.015-.438-2.87 0-2.24-1.887-.315-1.299 1.809-.853 1.799-1.299-.01-.417-1.486-.703-1.486-1.617C1.51 5.884 3.788 5.83 3.437 5.29c-.321-.492-.787-.627-.778-1.376.012-.912 1.54-1.029 1.612-1.1.22-.22 5.622-.092 8.296 0 .707.485 2.17 1.454 2.358 1.454Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.026 11.351v1.443a1.443 1.443 0 0 0 1.443 1.444h6.31l2.704-2.224a1.939 1.939 0 0 1 1.443-.721H19.9m0-7.157h-5.05l-2.165-1.443H4.748c-2.742 0-2.654 2.742-1.113 2.742h-.163a1.508 1.508 0 1 0 0 3.016h-.645a1.465 1.465 0 0 0-1.443 1.247 1.443 1.443 0 0 0 1.422 1.653h5.55",
                stroke: "#666",
                strokeLinecap: "round",
                fill: "#D8F0E9",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.673 14.326v4.796h-6.928v-4.364l-.59-1.061-2.508-2.83V4.26l.905-.667 1.69-.316c.438-.014 0-2.87 1.887-2.24 1.299-.315.853 1.809 1.299 1.799.417-.01.703-1.486 1.617-1.486 1.013-.441 1.067 1.838 1.606 1.486.492-.32.627-.786 1.375-.777.913.011 1.03 1.54 1.101 1.612.22.22.092 5.622 0 8.295-.485.708-1.454 2.17-1.454 2.359Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.59 3.427h-1.442a1.443 1.443 0 0 0-1.444 1.443v6.309l2.224 2.704a1.938 1.938 0 0 1 .722 1.443V19.3m7.156 0v-5.05l1.443-2.165V4.148c0-2.742-2.742-2.653-2.742-1.112v-.163a1.508 1.508 0 0 0-3.016 0v-.645A1.465 1.465 0 0 0 24.244.785a1.443 1.443 0 0 0-1.653 1.42v5.551",
                stroke: "#666",
                strokeLinecap: "round",
                fill: "#D8F0E9",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.812 29.326h-4.797v-6.928h4.364l1.062-.59 2.83-2.507h6.605l.668.904.315 1.69c.015.438 2.87 0 2.241 1.887.315 1.299-1.81.854-1.8 1.299.01.417 1.486.703 1.486 1.617.442 1.013-1.837 1.067-1.485 1.606.32.492.786.627.777 1.376-.011.912-1.54 1.03-1.612 1.1-.22.22-5.622.092-8.295 0-.708-.484-2.17-1.454-2.36-1.454Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.71 22.244V20.8a1.443 1.443 0 0 0-1.442-1.443h-6.31l-2.703 2.223a1.938 1.938 0 0 1-1.444.722h-3.974m0 7.156h5.05l2.165 1.443h7.937c2.742 0 2.654-2.742 1.113-2.742h.163a1.508 1.508 0 0 0 0-3.016h.645a1.465 1.465 0 0 0 1.443-1.246 1.443 1.443 0 0 0-1.421-1.654h-5.55",
                stroke: "#666",
                strokeLinecap: "round",
                fill: "#D8F0E9",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.943 19.525V14.73h5.544v4.108l.59 1.061 3.892 2.831v6.605l-.905.667-1.69.316c-.438.014 0 2.87-1.887 2.24-1.299.315-.854-1.809-1.299-1.799-.417.01-.703 1.486-1.617 1.486-1.013.441-1.067-1.837-1.606-1.486-.492.321-.627.787-1.376.777-.912-.01-1.03-1.54-1.1-1.611-.22-.22-.092-5.622 0-8.296.484-.707 1.454-1.914 1.454-2.103Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.913 30.168h1.443a1.443 1.443 0 0 0 1.443-1.443v-6.309l-3.607-2.704a1.937 1.937 0 0 1-.722-1.443v-3.974m-5.772 0v5.05L4.255 21.51v7.937c0 2.742 2.742 2.654 2.742 1.112v.163a1.508 1.508 0 1 0 3.016 0v.646a1.465 1.465 0 0 0 1.246 1.443 1.443 1.443 0 0 0 1.654-1.422v-5.55",
                stroke: "#666",
                strokeLinecap: "round",
                fill: "#D8F0E9",
                strokeLinejoin: "round"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/ParentalIcon.tsx




/* eslint-disable max-len */ 
var ParentalIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 36 36",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.25 20.992a3.75 3.75 0 0 0-2.84-3.637A14.85 14.85 0 0 0 18 4.492 14.85 14.85 0 0 0 3.59 17.355a3.75 3.75 0 0 0 .548 7.37A14.7 14.7 0 0 0 18 35.241a14.7 14.7 0 0 0 13.861-10.518 3.75 3.75 0 0 0 3.389-3.732Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 4.492c.936.018 2.561.03 3.25.665 0 0 .391.455.485 1.386a3.061 3.061 0 0 1-2.738 3.352 2.446 2.446 0 0 1-2.68-2.19 1.904 1.904 0 0 1 .033-.628M14.25 18.102c0 .932-1.008 1.688-2.25 1.688s-2.25-.75-2.25-1.688M21.75 18.102c0 .932 1.008 1.688 2.25 1.688s2.25-.75 2.25-1.688M14.48 26.352a4.11 4.11 0 0 0 3.52 1.5 4.11 4.11 0 0 0 3.52-1.5",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 4.492a14.85 14.85 0 0 1 14.41 12.863 3.75 3.75 0 0 1-.548 7.37A14.7 14.7 0 0 1 18 35.241 14.7 14.7 0 0 1 4.138 24.724a3.75 3.75 0 0 1-.549-7.37A14.85 14.85 0 0 1 18 4.493Zm0 0c.936.018 2.561.03 3.25.665 0 0 .391.455.485 1.386a3.061 3.061 0 0 1-2.738 3.352 2.446 2.446 0 0 1-2.68-2.19 1.904 1.904 0 0 1 .033-.628m-2.1 11.025c0 .932-1.008 1.688-2.25 1.688s-2.25-.75-2.25-1.688m12 0c0 .932 1.008 1.688 2.25 1.688s2.25-.75 2.25-1.688m-11.77 8.25a4.11 4.11 0 0 0 3.52 1.5 4.11 4.11 0 0 0 3.52-1.5",
                stroke: "#666",
                fill: "#D8F0E9",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/icons/FlexibleIcon.tsx




/* eslint-disable max-len */ 
var FlexibleIcon = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 36 36",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.805 23.688V11.376a1.894 1.894 0 0 0-1.894-1.894H15.233l-.942 2.353c-1.095 1.361-1.33 2.021-3.592 2.955-2.348.664-2.624.468-2.624.468v8.43h22.73Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M33.484 29.548a1.895 1.895 0 0 1-1.731 2.664H7.129a1.895 1.895 0 0 1-1.732-2.664l2.678-5.86h22.73l2.68 5.86ZM8.13 15.258a7.256 7.256 0 0 0 7.254-7.253 7.254 7.254 0 1 0-7.254 7.253Z",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.13 5.118v2.901l1.741 1.74",
                fill: "#D8F0E9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m14.291 11.835.39.313a.498.498 0 0 0 .074-.127l-.464-.186ZM10.7 14.79l.136.481a.477.477 0 0 0 .055-.019l-.19-.462Zm22.785 14.758.457-.203-.002-.005-.455.208Zm-1.731 2.664v-.5.5Zm-24.624 0v-.5.5Zm-1.732-2.664-.454-.207-.003.004.457.203Zm12.15-1.625a.5.5 0 0 0 0 1v-1Zm3.788 1a.5.5 0 0 0 0-1v1ZM8.63 5.118a.5.5 0 0 0-1 0h1Zm-.5 2.901h-.5a.5.5 0 0 0 .147.354l.353-.354Zm1.388 2.094a.5.5 0 0 0 .707-.707l-.707.707Zm-1.443 5.145.288-.408a.5.5 0 0 0-.788.408h.5Zm23.23 8.43V11.376h-1v12.312h1Zm0-12.312c0-.635-.252-1.244-.701-1.693l-.707.707c.261.261.408.616.408.986h1Zm-.701-1.693a2.394 2.394 0 0 0-1.693-.701v1c.37 0 .724.147.986.408l.707-.707ZM8.074 24.188h22.73v-1H8.075v1Zm24.953 5.563c.094.213.134.445.116.677l.997.079a2.393 2.393 0 0 0-.199-1.162l-.914.406Zm.116.677a1.394 1.394 0 0 1-.221.65l.838.544c.218-.334.348-.718.38-1.115l-.997-.08Zm-.221.65c-.127.194-.3.354-.504.465l.477.879c.35-.19.648-.465.865-.8l-.838-.545Zm-.504.465c-.204.11-.433.169-.665.169v1c.399 0 .791-.1 1.142-.29l-.477-.88Zm-.665.169H7.129v1h24.624v-1Zm-24.624 0c-.233 0-.461-.058-.665-.17l-.477.88c.35.19.743.29 1.142.29v-1Zm-.665-.17a1.395 1.395 0 0 1-.504-.465l-.839.545c.218.335.515.61.866.8l.477-.88Zm-.504-.465a1.395 1.395 0 0 1-.221-.65l-.997.08c.031.397.162.78.38 1.115l.838-.545Zm-.221-.65a1.394 1.394 0 0 1 .115-.676l-.914-.406c-.162.365-.23.764-.198 1.162l.997-.08Zm.113-.67 2.678-5.861-.91-.416-2.677 5.86.91.416Zm24.498-5.861 2.68 5.86.909-.416-2.68-5.86-.909.416Zm-12.803 5.027h3.788v-1h-3.788v1ZM8.13 14.758a6.753 6.753 0 0 1-6.753-6.753h-1a7.753 7.753 0 0 0 7.753 7.753v-1ZM1.377 8.005A6.754 6.754 0 0 1 8.13 1.25v-1A7.754 7.754 0 0 0 .377 8.005h1ZM8.13 1.25a6.753 6.753 0 0 1 6.754 6.754h1A7.753 7.753 0 0 0 8.13.25v1Zm-.5 3.867v2.901h1V5.118h-1Zm.147 3.255 1.74 1.74.708-.707-1.741-1.74-.707.707Zm6.125 3.149c-.585.726-.867 1.166-1.312 1.588-.42.395-.984.765-2.081 1.218l.381.924c1.165-.48 1.849-.908 2.386-1.416.511-.482.894-1.053 1.405-1.688l-.78-.627Zm-3.338 2.787c-1.162.328-1.785.436-2.104.466-.16.015-.228.009-.242.007-.006 0 .007 0 .031.009a.39.39 0 0 1 .112.057c.001 0 .002.002-.286.41-.289.408-.288.41-.286.41l.002.002.004.002c.003.002.006.005.01.006a.405.405 0 0 0 .054.031.833.833 0 0 0 .233.065c.11.014.258.016.461-.003.407-.039 1.096-.165 2.282-.5l-.272-.962Zm-2.99.949v8.43h1v-8.43h-1Zm7.31-7.253c0 .472-.049.932-.14 1.375l.979.203c.105-.51.16-1.038.16-1.578h-1Zm-.14 1.375a6.756 6.756 0 0 1-6.614 5.378v1a7.756 7.756 0 0 0 7.593-6.175l-.98-.203Zm14.167-.398H15.233v1h13.678v-1Zm-14.142.314-.942 2.353.928.372.942-2.354-.928-.371Z",
                fill: "#666"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/PerksAndBenefits.tsx

/* eslint-disable camelcase */ 









var iconKeys = {
    finance: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinanceIcon, {}),
    health_and_wellness: /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthAndWellnessIcon, {}),
    office_life: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficeLifeIcon, {}),
    professional_development: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfessionalDevelopmentIcon, {}),
    vacation_and_timeoff: /*#__PURE__*/ (0,jsx_runtime.jsx)(VacationAndTimeOffIcon, {}),
    parental_benefits: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParentalIcon, {}),
    work_flexibility: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexibleIcon, {}),
    diversity_and_inclusion: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiversityAndInclusionIcon, {})
};
var PerksAndBenefits = function(props) {
    var company = props.company;
    var perks_and_benefits = company.perks_and_benefits;
    var hasPerksOrBenefits = perks_and_benefits ? Object.keys(perks_and_benefits).reduce(function(pbCount, pbKey) {
        return pbCount + perks_and_benefits[pbKey].perks.length;
    }, 0) > 0 : false;
    return hasPerksOrBenefits ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobIndividualBody_module_default()).perksAndBenefits,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Perks and Benefits"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: Object.keys(perks_and_benefits).map(function(perkName) {
                    return perks_and_benefits[perkName].perks.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            iconKeys[perkName],
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: perks_and_benefits[perkName].name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: perks_and_benefits[perkName].perks.map(function(perkOrBenefit) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: perkOrBenefit.name
                                    }, perkOrBenefit.name);
                                })
                            })
                        ]
                    }, perkName) : null;
                })
            })
        ]
    }) : null;
};

;// CONCATENATED MODULE: ./src/components/JobClientProvidedLocation.tsx



var JobClientProvidedLocation = function(props) {
    var locations = props.locations;
    if (!locations) {
        return null;
    }
    var clientLocations = (0,_to_consumable_array/* default */.Z)(new Set(locations.map(function(x) {
        return x.geocoded_locations;
    }).flat().map(function(x) {
        return x ? x.formatted_address : null;
    }))).filter(function(location) {
        return location;
    }).join("; ");
    if (!clientLocations) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            "Client-provided location(s): ",
            clientLocations
        ]
    });
};

// EXTERNAL MODULE: ./src/components/JobAlert.module.scss
var JobAlert_module = __webpack_require__(3417);
var JobAlert_module_default = /*#__PURE__*/__webpack_require__.n(JobAlert_module);
;// CONCATENATED MODULE: ./src/components/JobAlertsModule.tsx









var JobAlertsModule = function(props) {
    var jobCategory = props.jobCategory, jobLocations = props.jobLocations, jobLevel = props.jobLevel, jobNormalizedTitle = props.jobNormalizedTitle;
    var onSuccessRefChange = function(node) {
        if (node) {
            (0,build/* triggerSnowplowImpressionEvent */.XQ)(node);
        }
    };
    var handleFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var ref, apiData, optinSuccess;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        apiData = {
                            location: jobLocations === null || jobLocations === void 0 ? void 0 : (ref = jobLocations[0]) === null || ref === void 0 ? void 0 : ref.value,
                            category: jobCategory === null || jobCategory === void 0 ? void 0 : jobCategory.value,
                            level: jobLevel,
                            keyword: jobNormalizedTitle,
                            email: values === null || values === void 0 ? void 0 : values.email,
                            newsletter: values === null || values === void 0 ? void 0 : values.newsletter
                        };
                        _ctx.next = 4;
                        return (0,api/* jobAlertsSubscribeRequest */.Ml)(apiData);
                    case 4:
                        optinSuccess = _ctx.sent;
                        return _ctx.abrupt("return", optinSuccess);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFormSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var jobAlertsProps = {
        handleFormSubmit: handleFormSubmit,
        jobCategory: jobCategory === null || jobCategory === void 0 ? void 0 : jobCategory.label,
        jobLocations: jobLocations,
        successRef: onSuccessRefChange
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (JobAlert_module_default()).jobAlerts,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* JobAlerts */.ov, (0,src_object_spread/* default */.Z)({}, jobAlertsProps))
    });
};


;// CONCATENATED MODULE: ./src/components/JobAlert.tsx




var JobAlert = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var FEATURE_FLAG_INHOUSE_JOB_ALERTS = useFeatureFlagsState().FEATURE_FLAG_INHOUSE_JOB_ALERTS;
    var job = props.job, company = props.company;
    if (!FEATURE_FLAG_INHOUSE_JOB_ALERTS) {
        return null;
    }
    if (job.locations && job.locations.length > 1) {
        return null;
    }
    if (company.state !== "limited") {
        return null;
    }
    var category = {
        value: (ref = job.categories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.code,
        label: (ref2 = job.categories) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.value
    };
    var location = {
        value: (ref4 = job.locations) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.value,
        label: (ref6 = job.locations) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.value
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertsModule, {
        jobNormalizedTitle: job.normalizedTitle,
        jobLevel: (ref8 = job.levels) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.value,
        jobLocations: [
            location
        ],
        jobCategory: category
    });
};


;// CONCATENATED MODULE: ./src/components/JobIndividualBody.tsx



/* eslint-disable react/no-danger */ 









var JobIndividualBody = function(props) {
    var ref;
    var ref1 = (0,AppContext/* useAppState */.mr)(), job = ref1.job, company = ref1.company;
    var setIsOpen = props.setIsOpen, isDirectApply = props.isDirectApply;
    var trackApplyProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,tracking/* getJobTrackingProps */.Cg)(job, company)), {
        placement_position: "desktop_bottom"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (JobIndividualBody_module_default()).jobBodyContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: (JobIndividualBody_module_default()).jobBodyDescription,
                children: job === null || job === void 0 ? void 0 : job.compiled_contents.map(function(x, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: x
                                }
                            }, esm_browser_v4()),
                            !isDirectApply && index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlert, {
                                job: job,
                                company: company
                            }) : null
                        ]
                    }, esm_browser_v4());
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (JobIndividualBody_module_default()).applyContainer,
                children: (job === null || job === void 0 ? void 0 : job.state) === "live" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplyButton, {
                    className: (JobIndividualBody_module_default()).applyButton,
                    jobId: job === null || job === void 0 ? void 0 : job.id,
                    setIsOpen: setIsOpen,
                    isDirectApply: isDirectApply,
                    trackingProps: trackApplyProps
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (JobIndividualBody_module_default()).jobBodyFooter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobClientProvidedLocation, {
                        locations: job === null || job === void 0 ? void 0 : job.locations
                    }),
                    "Job ID: ",
                    job === null || job === void 0 ? void 0 : (ref = job.ats_info) === null || ref === void 0 ? void 0 : ref.id
                ]
            }),
            job.has_jwp_hiring_manager_playlist ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JWPlayerVideoModule, {
                title: "Meet the Hiring Manager",
                description: "Hear directly from the hiring manager about what it is like to work here.",
                tagName: job === null || job === void 0 ? void 0 : job.id
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PerksAndBenefits, {
                company: company
            }),
            company.has_jwp_company_playlist ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JWPlayerVideoModule, {
                title: "Company Videos",
                description: "Hear directly from employees about what it is like to work at ".concat(company.name, "."),
                tagName: "".concat(company === null || company === void 0 ? void 0 : company.name, ",final")
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/components/JobApplyButtonSideBarModule.module.scss
var JobApplyButtonSideBarModule_module = __webpack_require__(5810);
var JobApplyButtonSideBarModule_module_default = /*#__PURE__*/__webpack_require__.n(JobApplyButtonSideBarModule_module);
;// CONCATENATED MODULE: ./src/components/JobApplyButtonSideBarModule.tsx




var JobApplyButtonSideBarModule = function(props) {
    var jobState = props.jobState, jobId = props.jobId, trackJobApplyProps = props.trackJobApplyProps, _mobile = props.mobile, mobile = _mobile === void 0 ? false : _mobile, setIsOpen = props.setIsOpen, isDirectApply = props.isDirectApply;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((JobApplyButtonSideBarModule_module_default()).jobApplyContainer, " ").concat(mobile ? (JobApplyButtonSideBarModule_module_default()).mobile : ""),
        children: jobState === "live" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplyButton, {
            className: (JobApplyButtonSideBarModule_module_default()).applyButton,
            jobId: jobId,
            trackingProps: trackJobApplyProps,
            setIsOpen: setIsOpen,
            isDirectApply: isDirectApply
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (JobApplyButtonSideBarModule_module_default()).archivedJobMessage,
                    children: "This job is no longer available."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SquareButton */.LE, {
                    className: (JobApplyButtonSideBarModule_module_default()).applyButton,
                    href: "/search",
                    target: "_blank",
                    color: "mint",
                    children: "Search all jobs"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/JobIndividualSidebar.module.scss
var JobIndividualSidebar_module = __webpack_require__(5950);
var JobIndividualSidebar_module_default = /*#__PURE__*/__webpack_require__.n(JobIndividualSidebar_module);
;// CONCATENATED MODULE: ./src/components/SidebarJobTile.tsx

/* eslint-disable camelcase */ 



var SidebarJobTile = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var _$ref;
    var jobSearchData = props.jobSearchData, onClick = props.onClick, orderNum = props.orderNum;
    var title = jobSearchData.title, short_title = jobSearchData.short_title, company = jobSearchData.company, remote_work_location_type = jobSearchData.remote_work_location_type, locations = jobSearchData.locations;
    var location = remote_work_location_type === "virtual" ? "Remote" : (_$ref = locations[0]) === null || _$ref === void 0 ? void 0 : _$ref.address;
    var trackingProps = JSON.stringify({
        sp_impression_component: "tile",
        sp_impression_tile_type: "job",
        sp_impression_insert_type: null,
        sp_impression_modal_type: null,
        sp_impression_position: "right_rail",
        sp_tile_type: "job",
        sp_tile_entity_id: jobSearchData.legacy_id.toString(),
        sp_tile_entity_uuid: jobSearchData.id.toString(),
        sp_tile_order: orderNum,
        sp_tile_location: "similar_jobs",
        sp_tile_company_id: company === null || company === void 0 ? void 0 : company.legacy_id.toString(),
        sp_click_component: "tile",
        sp_click_component_tile_type: "job",
        sp_click_position: "right_rail",
        sp_click_target_page_section: "job_detail"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            onClick: onClick,
            role: "presentation",
            "data-tracking-event-type": "impression",
            "data-tracking-props": trackingProps,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (JobIndividualSidebar_module_default()).jobTileLink,
                    href: "/jobs/".concat(company === null || company === void 0 ? void 0 : company.short_name, "/").concat(short_title),
                    target: "_blank",
                    onClick: function() {
                        return (0,build/* triggerSnowplowClickEvent */.jL)(JSON.parse(trackingProps));
                    },
                    children: truncateStringWithEllipsis(title, 75)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: truncateStringWithEllipsis(company === null || company === void 0 ? void 0 : company.name, 25)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: location
                })
            ]
        })
    });
});

;// CONCATENATED MODULE: ./src/components/SimilarJobsSidebarModule.tsx






var sidebarJobTileClickedTracking = function(event, trackingProps) {
    (0,tracking/* museTrack */.YU)("Job Tile Clicked", trackingProps);
};
var SimilarJobsSidebarModule = function(props) {
    var ref, ref1;
    var similarJobs = props.similarJobs, jobId = props.jobId;
    // We only ever want a max of three jobs, and we don't want to include the job we are displaying, so we request 4 and filter it out
    var tiles = similarJobs === null || similarJobs === void 0 ? void 0 : (ref = similarJobs.hits) === null || ref === void 0 ? void 0 : ref.filter(function(searchHit) {
        return searchHit.hit.legacy_id !== jobId;
    }).slice(0, 3).map(function(searchHit, index) {
        var hit = searchHit.hit;
        var trackingProps = (0,src_object_spread/* default */.Z)({}, (0,tracking/* getJobSearchHitTrackingProps */.eX)(hit), {
            placement_position: "job detail page",
            placement: "Individual Job",
            order_num: index + 1,
            recommended: true
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tracking/* TrackedElement */.cg, {
            eventProps: trackingProps,
            eventName: "Job Tile Viewed",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarJobTile, {
                jobSearchData: hit,
                orderNum: index + 1,
                onClick: function(event) {
                    return sidebarJobTileClickedTracking(event, trackingProps);
                }
            })
        }, hit.id);
    });
    return similarJobs && (similarJobs === null || similarJobs === void 0 ? void 0 : (ref1 = similarJobs.hits) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobIndividualSidebar_module_default()).similarJobsModule,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Similar Jobs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: tiles
            })
        ]
    }) : null;
};

;// CONCATENATED MODULE: ./src/components/SuggestedSearchesSidebarModule.tsx







var SearchLink = function(props) {
    var href = props.href, displayText = props.displayText, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        target: "_blank",
        href: href,
        onClick: onClick,
        children: displayText
    });
};
var SuggestedSearchesSidebarModule = function(props) {
    var ref, ref1, ref2;
    var job = props.job, company = props.company, museWebHost = props.museWebHost, trackingProps = props.trackingProps;
    var trackLinkClick = function(placementPosition, suggestedSearchType) {
        (0,tracking/* museTrack */.YU)("Jobs Individual Link Clicked", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, trackingProps), {
            placement_position: placementPosition,
            click_origin: "suggested_search_".concat(suggestedSearchType)
        }));
    };
    var suggestedSearchLinks = [
        {
            suggestedSearchType: "level",
            href: "".concat(museWebHost, "/search/level/").concat((ref = job === null || job === void 0 ? void 0 : job.levels[0]) === null || ref === void 0 ? void 0 : ref.value),
            displayText: "".concat((ref1 = job === null || job === void 0 ? void 0 : job.levels[0]) === null || ref1 === void 0 ? void 0 : ref1.display, " jobs"),
            active: !!(job === null || job === void 0 ? void 0 : (ref2 = job.levels) === null || ref2 === void 0 ? void 0 : ref2.length)
        },
        {
            suggestedSearchType: "company",
            href: "".concat(museWebHost, "/hiring/company/").concat(company === null || company === void 0 ? void 0 : company.short_name),
            displayText: "".concat(company === null || company === void 0 ? void 0 : company.name, " jobs"),
            active: true
        },
        {
            suggestedSearchType: "alljobs",
            href: "".concat(museWebHost, "/hiring"),
            displayText: "All jobs",
            active: true
        }, 
    ];
    var category = job === null || job === void 0 ? void 0 : job.categories[0];
    if ((category === null || category === void 0 ? void 0 : category.value.toLowerCase()) !== "unknown") {
        var ref3;
        suggestedSearchLinks = [
            {
                suggestedSearchType: "category",
                href: "".concat(museWebHost, "/hiring/category/").concat(category === null || category === void 0 ? void 0 : category.code),
                displayText: "".concat(category === null || category === void 0 ? void 0 : category.value, " jobs"),
                active: !!(job === null || job === void 0 ? void 0 : (ref3 = job.categories) === null || ref3 === void 0 ? void 0 : ref3.length)
            }
        ].concat((0,_to_consumable_array/* default */.Z)(suggestedSearchLinks));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobIndividualSidebar_module_default()).suggestedSearchesModule,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Suggested Searches"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: suggestedSearchLinks.map(function(searchLink, index) {
                    return searchLink.active ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchLink, {
                            href: searchLink.href,
                            displayText: searchLink.displayText,
                            onClick: function() {
                                trackLinkClick(index + 1, searchLink.suggestedSearchType);
                            }
                        })
                    }, "suggested-search-link-".concat(searchLink.suggestedSearchType)) : null;
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/AdditionalJobLinkList.module.scss
var AdditionalJobLinkList_module = __webpack_require__(9039);
var AdditionalJobLinkList_module_default = /*#__PURE__*/__webpack_require__.n(AdditionalJobLinkList_module);
;// CONCATENATED MODULE: ./src/components/AdditionalJobLinkList.tsx







var AdditionalJobLinkList = function() {
    var ref = (0,react.useState)(false), viewAll = ref[0], setViewAll = ref[1];
    var ref1 = (0,react.useState)(false), isMobileScreen = ref1[0], setIsMobileScreen = ref1[1];
    var job = (0,AppContext/* useAppState */.mr)().job;
    var locations = job.locations, categories = job.categories, normalizedTitle = job.normalizedTitle;
    if (!(locations === null || locations === void 0 ? void 0 : locations.length)) return null;
    var handleWindowResize = (0,react.useCallback)(function() {
        setIsMobileScreen(window.innerWidth < 768);
    }, []);
    (0,react.useEffect)(function() {
        var mobile = window.matchMedia("(max-width:768px)");
        mobile.addEventListener("resize", handleWindowResize);
        return function() {
            mobile.removeEventListener("change", handleWindowResize);
        };
    }, []);
    var showViewMore = (0,react.useCallback)(function() {
        var totalResults = locations.length * 3;
        switch(true){
            case isMobileScreen && totalResults > 10:
            case !isMobileScreen && totalResults > 8:
                return true;
            default:
                return false;
        }
    }, [
        isMobileScreen
    ]);
    var viewAllOnClick = function() {
        setViewAll(!viewAll);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "aria-labelledby": "additionalJobLinkList",
        className: "".concat((AdditionalJobLinkList_module_default()).additionalJobLinkList),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                id: "additionalJobLinkList",
                className: "".concat((AdditionalJobLinkList_module_default()).linkHeader),
                children: "Search Additional Jobs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((AdditionalJobLinkList_module_default()).linkListContainer, " ").concat(viewAll ? (AdditionalJobLinkList_module_default()).fullList : (AdditionalJobLinkList_module_default()).limitedList),
                children: [
                    normalizedTitle && locations.map(function(location) {
                        var isRemote = locationIsRemote(location);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "".concat((AdditionalJobLinkList_module_default()).singleJobLink),
                            "data-linktype": "keywordAndLocation",
                            "data-pos": "bottom_search_additional_jobs",
                            href: "/hiring/location/".concat(slugifyLocation(location.value), "/keyword/").concat(slugify(normalizedTitle), "/"),
                            target: "_blank",
                            "aria-label": isRemote ? "Search Remote-friendly ".concat(normalizedTitle, " Jobs") : "Search ".concat(normalizedTitle, " Jobs in ").concat(location.value),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: isRemote ? "Remote-friendly ".concat(normalizedTitle, " Jobs") : "".concat(normalizedTitle, " Jobs in ").concat(location.value)
                            })
                        }, location.id);
                    }),
                    locations.map(function(location) {
                        var slugifiedValue = slugifyLocation(location.value);
                        var isRemote = locationIsRemote(location);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "".concat((AdditionalJobLinkList_module_default()).singleJobLink),
                            "data-linktype": "location",
                            "data-pos": "bottom_search_addtional_jobs",
                            href: "/hiring/location/".concat(slugifiedValue, "/"),
                            target: "_blank",
                            "aria-label": isRemote ? "Search Remote-friendly Jobs" : "Search Jobs in ".concat(location.value),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: isRemote ? "Remote-friendly Jobs" : "Jobs in ".concat(location.value)
                            })
                        }, location.id);
                    }),
                    categories.length > 0 && locations.map(function(location) {
                        var category = categories[0].value;
                        var categoryLink = categories[0].code;
                        var slugifiedLocation = slugifyLocation(location.value);
                        var isRemote = locationIsRemote(location);
                        if (category.toLocaleLowerCase() === "unknown") return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "".concat((AdditionalJobLinkList_module_default()).singleJobLink),
                            href: "/hiring/location/".concat(slugifiedLocation, "/category/").concat(categoryLink, "/"),
                            target: "_blank",
                            "data-linktype": "categoryAndLocation",
                            "data-pos": "bottom_search_addtional_jobs",
                            "aria-label": isRemote ? "Search ".concat(category, " Remote-friendly Jobs") : "Search ".concat(category, " Jobs in ").concat(location.value),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: isRemote ? "".concat(category, " Remote-friendly Jobs") : "".concat(category, " Jobs in ").concat(location.value)
                            })
                        }, location.id);
                    })
                ]
            }),
            showViewMore() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((AdditionalJobLinkList_module_default()).gradientOverlay, " ").concat(viewAll ? (AdditionalJobLinkList_module_default()).noGradient : "", " viewMoreSection"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (AdditionalJobLinkList_module_default()).viewAllContentContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AdditionalJobLinkList_module_default()).viewAllSeparatorLine
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: viewAllOnClick,
                            type: "button",
                            "data-viewbutton": "viewbutton",
                            className: "".concat((AdditionalJobLinkList_module_default()).viewMoreButton, " ").concat(viewAll ? (AdditionalJobLinkList_module_default()).arrowUpAlignment : ""),
                            children: [
                                viewAll ? /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* ArrowUpShape */.ho, {
                                    title: "ArrowUpShape",
                                    titleId: "ArrowUpShape",
                                    className: (AdditionalJobLinkList_module_default()).arrowStyling
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* ArrowDownShape */.HY, {
                                    title: "ArrowDownShape",
                                    titleId: "ArrowDownShape",
                                    className: (AdditionalJobLinkList_module_default()).arrowStyling
                                }),
                                viewAll ? "VIEW LESS" : "VIEW MORE"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AdditionalJobLinkList_module_default()).viewAllSeparatorLine
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/JobIndividualSidebar.tsx

















var JobIndividualSidebar = function(props) {
    var getSimilarJobs = props.getSimilarJobs, setIsOpen = props.setIsOpen, isDirectApply = props.isDirectApply;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState("right_rail"), 2), buttonPlacement = ref[0], setButtonPlacement = ref[1];
    var ref1 = (0,AppContext/* useAppState */.mr)(), job = ref1.job, company = ref1.company, similarJobs = ref1.similarJobs;
    var ref2 = (0,config["default"])(), museWebHost = ref2.publicRuntimeConfig.museWebHost;
    var appDispatch = (0,AppContext/* useAppDispatch */.TL)();
    var jobTrackingProps = (0,tracking/* getJobTrackingProps */.Cg)(job, company);
    var trackJobApplyProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, jobTrackingProps), {
        placement_position: buttonPlacement
    });
    var setSimilarJobsCallback = function(similarJobsSearchResult) {
        appDispatch({
            type: appContextInterfaces/* SimilarJobsActionTypes.updateSimilarJobs */.fn.updateSimilarJobs,
            payload: similarJobsSearchResult
        });
    };
    (0,react.useEffect)(function() {
        var ref;
        if (!(similarJobs === null || similarJobs === void 0 ? void 0 : (ref = similarJobs.hits) === null || ref === void 0 ? void 0 : ref.length)) {
            getSimilarJobs(job, setSimilarJobsCallback);
        }
    }, []);
    (0,react.useEffect)(function() {
        if ((0,browser/* isMobile */.tq)()) {
            setButtonPlacement("mobile_fixed_bottom");
        }
    }, []);
    (0,react.useEffect)(function() {
        if (similarJobs) {
            (0,build/* trackSnowplowImpressions */.VB)();
        }
    }, [
        similarJobs === null || similarJobs === void 0 ? void 0 : similarJobs.hits
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInformationModule, {
                company: company,
                job: job,
                displayOnMobile: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                className: (JobIndividualSidebar_module_default()).jobSidebarContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplyButtonSideBarModule, {
                        jobState: job === null || job === void 0 ? void 0 : job.state,
                        jobId: job === null || job === void 0 ? void 0 : job.id,
                        trackJobApplyProps: trackJobApplyProps,
                        setIsOpen: setIsOpen,
                        isDirectApply: isDirectApply
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (JobIndividualSidebar_module_default()).sidebarModules,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimilarJobsSidebarModule, {
                                similarJobs: similarJobs,
                                jobId: job.id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedSearchesSidebarModule, {
                                job: job,
                                company: company,
                                museWebHost: museWebHost,
                                trackingProps: jobTrackingProps
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdditionalJobLinkList, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplyButtonSideBarModule, {
                jobState: job === null || job === void 0 ? void 0 : job.state,
                jobId: job === null || job === void 0 ? void 0 : job.id,
                trackJobApplyProps: trackJobApplyProps,
                mobile: true,
                setIsOpen: setIsOpen,
                isDirectApply: isDirectApply
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/JobPostJsonLd.tsx




/* eslint-disable camelcase */ /* eslint-disable react/no-danger */ 




/**
 * Construct a job url.
 */ var getJobUrl = function(companyShortName, jobShortname) {
    var ref = (0,config["default"])(), appEnv = ref.publicRuntimeConfig.appEnv;
    var path = "/jobs/".concat(companyShortName, "/").concat(jobShortname);
    return appEnv === "production" ? "https://www.themuse.com".concat(path) : "https://www.staging-themuse.com".concat(path);
};
/**
 * Retrieve the parts of the location from the geocoded properties of an address_components
 */ var getParts = function(item) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (item === null || item === void 0 ? void 0 : (ref = item.types) === null || ref === void 0 ? void 0 : ref.includes("street_number")) return {
        streetAddress: item.long_name
    };
    if (item === null || item === void 0 ? void 0 : (ref1 = item.types) === null || ref1 === void 0 ? void 0 : ref1.includes("route")) return {
        route: item.long_name
    };
    if (item === null || item === void 0 ? void 0 : (ref2 = item.types) === null || ref2 === void 0 ? void 0 : ref2.includes("locality")) return {
        addressLocality: item.long_name
    };
    if (item === null || item === void 0 ? void 0 : (ref3 = item.types) === null || ref3 === void 0 ? void 0 : ref3.includes("postal_code")) return {
        postalCode: item.short_name
    };
    if (item === null || item === void 0 ? void 0 : (ref4 = item.types) === null || ref4 === void 0 ? void 0 : ref4.includes("administrative_area_level_1")) return {
        addressRegion: item.short_name
    };
    if (item === null || item === void 0 ? void 0 : (ref5 = item.types) === null || ref5 === void 0 ? void 0 : ref5.includes("country")) return {
        addressCountry: item.short_name
    };
    return {};
};
/**
 * Generates the JSON address object with whatever keys we can find.
 */ var getJSONFromGeocodedLocation = function(location) {
    var geocodedLocations = Array.isArray(location === null || location === void 0 ? void 0 : location.geocoded_locations) ? location.geocoded_locations : [
        location === null || location === void 0 ? void 0 : location.geocoded_locations
    ];
    var stringifiedGeo = geocodedLocations === null || geocodedLocations === void 0 ? void 0 : geocodedLocations.map(function(geo) {
        var ref, ref1;
        // Now we loop again over the addresses
        var result = (ref1 = geo === null || geo === void 0 ? void 0 : (ref = geo.address_components) === null || ref === void 0 ? void 0 : ref.map(getParts)) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(a, b) {
            return (0,src_object_spread/* default */.Z)({}, a, b);
        }, {});
        // Append the json type.
        if (result) {
            result["@type"] = "PostalAddress";
            // Combine the street address and route into a full local address.
            if ((result === null || result === void 0 ? void 0 : result.streetAddress) && (result === null || result === void 0 ? void 0 : result.route)) {
                result.streetAddress = "".concat(result.streetAddress, " ").concat(result.route);
                delete result.route;
            }
            // Remove all the empty/falsy properties.
            Object.keys(result).forEach(function(key) {
                if (!result[key]) {
                    delete result[key];
                }
            });
        }
        return result ? {
            "@type": "Place",
            address: result
        } : {};
    })// Reduce to a single array.
    .flat()// Remove empty objects or ones that only have the @type.
    .filter(function(x) {
        return Object.keys(x).length > 1;
    })// Remove null and undefined entries
    .filter(Boolean).map(function(x) {
        return JSON.stringify(x);
    });
    return (stringifiedGeo === null || stringifiedGeo === void 0 ? void 0 : stringifiedGeo.length) ? (0,_to_consumable_array/* default */.Z)(new Set(stringifiedGeo)).map(function(x) {
        return JSON.parse(x);
    }) : [];
};
/**
 * Generate a JSON address format for locations.
 */ var getMuseLocations = function(locations) {
    return locations.filter(function(location) {
        return !locationIsRemote(location);
    }).map(function(location) {
        return {
            "@type": "Place",
            address: {
                "@type": "PostalAddress",
                addressLocality: location === null || location === void 0 ? void 0 : location.city,
                addressCountry: location === null || location === void 0 ? void 0 : location.country,
                addressRegion: location === null || location === void 0 ? void 0 : location.state
            }
        };
    });
};
/**
 * Filter for actual locations and format them for consumption by google.
 */ var getJobLocations = function(locations) {
    var geoCodedLocations = locations.filter(function(location) {
        return !locationIsRemote(location);
    }).map(getJSONFromGeocodedLocation).flat();
    return geoCodedLocations.length < 1 ? getMuseLocations(locations) : geoCodedLocations;
};
/**
 * Convert the perks and benifits object into a single comma delimited string of perk names.
 */ var getBenefitsString = function(perkList) {
    return Object.keys(perkList).map(function(group) {
        return perkList[group].perks.map(function(perk) {
            return perk.name;
        }).filter(Boolean).join(",");
    }).filter(Boolean).join(", ");
};
var generateJobPostingJson = function(props) {
    var company = props.company, job = props.job, isDirectApply = props.isDirectApply;
    var perks_and_benefits = company.perks_and_benefits, companyName = company.name, logo = company.logo, companyShortName = company.short_name;
    var locations = job.locations, datePosted = job.posted_at, compiled_contents = job.compiled_contents, title = job.name, validThrough = job.valid_through, jobShortName = job.short_name, ats_info = job.ats_info;
    var jobLocation = getJobLocations(locations);
    var isFlexibleRemote = locations === null || locations === void 0 ? void 0 : locations.find(function(location) {
        return locationIsRemote(location);
    });
    var jobBenefits = getBenefitsString(perks_and_benefits);
    var jsonld = (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "JobPosting",
        datePosted: datePosted,
        description: compiled_contents.join(""),
        experienceRequirements: "no requirements",
        hiringOrganization: {
            "@type": "Organization",
            name: companyName,
            logo: getCompanyLogo(logo)
        }
    }, isDirectApply && {
        directApply: true
    }, (jobLocation === null || jobLocation === void 0 ? void 0 : jobLocation.length) && {
        jobLocation: jobLocation
    }, isFlexibleRemote && {
        jobLocationType: "TELECOMMUTE",
        applicantLocationRequirements: {
            "@type": "Country",
            sameAs: "https://www.wikidata.org/wiki/Q30",
            name: "USA"
        }
    }), {
        title: title,
        employmentType: "OTHER",
        url: getJobUrl(companyShortName, jobShortName)
    }), validThrough && {
        validThrough: validThrough
    }), {
        identifier: {
            "@type": "PropertyValue",
            name: companyName,
            value: ats_info === null || ats_info === void 0 ? void 0 : ats_info.id
        }
    }), jobBenefits && {
        jobBenefits: jobBenefits
    });
    return jsonld;
};
var JobPostJsonLd = function(props) {
    var ref;
    var ref1 = (0,AppContext/* useAppState */.mr)(), company = ref1.company, job = ref1.job;
    var isDirectApply = props.isDirectApply;
    var jobLocation = getJobLocations(job === null || job === void 0 ? void 0 : job.locations);
    var isFlexibleRemote = job === null || job === void 0 ? void 0 : (ref = job.locations) === null || ref === void 0 ? void 0 : ref.find(function(location) {
        return locationIsRemote(location);
    });
    var hasValidLocation = isFlexibleRemote || (jobLocation === null || jobLocation === void 0 ? void 0 : jobLocation.length);
    if (!hasValidLocation || (job === null || job === void 0 ? void 0 : job.state) !== "live") {
        return null;
    }
    var jsonld = generateJobPostingJson({
        company: company,
        job: job,
        isDirectApply: isDirectApply
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        strategy: "beforeInteractive",
        id: "JobPost-JSON",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(jsonld)
        }
    }, "JobPost-JSON");
};
// WARNING: This is for unit testing only and should NEVER be used directly outside this file.
var generateJobPostingJsonTestingOnly = (/* unused pure expression or super */ null && (generateJobPostingJson));


// EXTERNAL MODULE: ./src/components/DirectApplyModal.module.scss
var DirectApplyModal_module = __webpack_require__(1676);
var DirectApplyModal_module_default = /*#__PURE__*/__webpack_require__.n(DirectApplyModal_module);
;// CONCATENATED MODULE: ./src/components/DirectApplyModal.tsx




// generate iframe and modal
var DirectApplyModal = function(props) {
    var isOpen = props.isOpen, link = props.link, setIsOpen = props.setIsOpen;
    // On Safari the body of the iframe is not the same size as the iframe. But instead set to 100% content height.
    // This means that we cannot scroll to an anchor on Safari.
    var label = "Direct Apply Modal.";
    // left empty on purpose
    var openModal = react.useCallback(function() {
        console.info("The Direct apply modal to ".concat(link, " was opened."));
    // TODO: place onOpen tracking info here
    }, []);
    var closeModal = react.useCallback(function() {
        console.info("The Direct apply modal to ".concat(link, " was closed."));
    // TODO: place onClose tracking info here
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Modal */.u_, {
        label: label,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        onOpen: openModal,
        onClose: closeModal,
        timer: 0,
        closeButtonClassName: (DirectApplyModal_module_default()).jobApplyModalCloseButton,
        containerClassName: (DirectApplyModal_module_default()).jobApplyModalContainer,
        contentClassName: (DirectApplyModal_module_default()).jobApplyModalContent,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            title: "greenhouse apply frame",
            src: "".concat(link, "#application"),
            width: "300",
            height: "500",
            loading: "lazy",
            seamless: true
        })
    });
};


// EXTERNAL MODULE: ./src/styles/Home.module.scss
var Home_module = __webpack_require__(4865);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(4453);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
;// CONCATENATED MODULE: ./src/pages/index.tsx



























var setUserCarmenData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(setUserLocation) {
        var carmenResponse, msg;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCarmenData();
                case 3:
                    carmenResponse = _ctx.sent;
                    if (carmenResponse) {
                        setUserLocation(JSON.stringify(carmenResponse));
                    }
                    _ctx.next = 11;
                    break;
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    msg = "".concat("job-renderer", " was unable to load location from Carmen.");
                    console.warn(msg, JSON.stringify((0,logging/* formatLog */.U)({
                        error: _ctx.t0
                    })));
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function setUserCarmenData(setUserLocation) {
        return _ref.apply(this, arguments);
    };
}();
var UserInit = function(props) {
    var children = props.children;
    var user = (0,AppContext/* useAppState */.mr)().user;
    var ref = (0,_sliced_to_array/* default */.Z)(useSessionStorage("user_location"), 2), userLocation = ref[0], setUserLocation = ref[1];
    var appDispatch = (0,AppContext/* useAppDispatch */.TL)();
    react.useEffect(function() {
        var setUser = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var apiUser, msg;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,api/* getUser */.PR)();
                        case 3:
                            apiUser = _ctx.sent;
                            if (apiUser && apiUser.logged_in) {
                                appDispatch({
                                    type: appContextInterfaces/* UserActionTypes.updateUser */.F6.updateUser,
                                    payload: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, apiUser), {
                                        location: userLocation ? JSON.parse(userLocation) : null
                                    })
                                });
                            } else {
                                appDispatch({
                                    type: appContextInterfaces/* UserActionTypes.resetUser */.F6.resetUser
                                });
                            }
                            _ctx.next = 11;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            msg = "Job Renderer was unable retrieve the user.";
                            console.warn(msg, JSON.stringify((0,logging/* formatLog */.U)({
                                error: _ctx.t0
                            })));
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }));
            return function setUser() {
                return _ref.apply(this, arguments);
            };
        }();
        setUser().then(function() {
            // NOTE: An email with `themuse.com` does not mean the user is an admin
            var isMuser = (user === null || user === void 0 ? void 0 : user.email) && user.email.split("@")[1] === "themuse.com";
            var _logged_in, _id;
            (0,tracking/* userTrack */.Uk)({
                signed_in: (_logged_in = user.logged_in) !== null && _logged_in !== void 0 ? _logged_in : false,
                is_muser: isMuser,
                is_admin: isMuser,
                user_id: (_id = user.id) !== null && _id !== void 0 ? _id : null
            });
        }).catch(function(error) {
            (0,tracking/* userTrack */.Uk)({
                signed_in: false,
                is_muser: false,
                is_admin: false,
                user_id: null
            });
            console.error(error);
        });
    }, []);
    react.useEffect(function() {
        setUserCarmenData(setUserLocation);
    }, []);
    react.useEffect(function() {
        appDispatch({
            type: appContextInterfaces/* UserActionTypes.updateUser */.F6.updateUser,
            payload: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, user), {
                location: userLocation ? JSON.parse(userLocation) : null
            })
        });
    }, [
        userLocation
    ]);
    react.useEffect(function() {
        // NOTE: An email with `themuse.com` does not mean the user is an admin
        var isMuser = (user === null || user === void 0 ? void 0 : user.email) && user.email.split("@")[1] === "themuse.com";
        var ref, ref1;
        (0,tracking/* userTrack */.Uk)({
            signed_in: (ref = user === null || user === void 0 ? void 0 : user.logged_in) !== null && ref !== void 0 ? ref : false,
            is_muser: isMuser,
            is_admin: isMuser,
            user_id: (ref1 = user === null || user === void 0 ? void 0 : user.id) !== null && ref1 !== void 0 ? ref1 : null
        });
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */ var handleSearchSubmit = function() {
    (0,tracking/* museTrack */.YU)("Header Link Clicked", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,tracking/* genBaseProps */.rC)()), {
        header_link: "search_bar",
        link_name: "search_bar"
    }));
};
var getSimilarJobs = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(job, callback) {
        var ref, ref1, similarJobsRequest, similarJobsSearchResult, msg;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(job !== null)) {
                        _ctx.next = 14;
                        break;
                    }
                    ;
                    similarJobsRequest = {
                        query: job === null || job === void 0 ? void 0 : (ref = job.name) === null || ref === void 0 ? void 0 : ref.split(" ").slice(0, 3).join(" "),
                        level: job === null || job === void 0 ? void 0 : (ref1 = job.levels) === null || ref1 === void 0 ? void 0 : ref1.map(function(level) {
                            return (level === null || level === void 0 ? void 0 : level.value) === "senior" ? "senior,management" : level === null || level === void 0 ? void 0 : level.value;
                        }).join(","),
                        limit: 4
                    };
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return (0,api/* searchJobs */.B5)(similarJobsRequest);
                case 6:
                    similarJobsSearchResult = _ctx.sent;
                    callback(similarJobsSearchResult);
                    _ctx.next = 14;
                    break;
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](3);
                    msg = "Job Renderer was unable fetch similar jobs for: ".concat(job === null || job === void 0 ? void 0 : job.short_name, ".");
                    console.warn(msg, JSON.stringify((0,logging/* formatLog */.U)({
                        error: _ctx.t0
                    })));
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                10
            ]
        ]);
    }));
    return function getSimilarJobs(job, callback) {
        return _ref.apply(this, arguments);
    };
}();
var Home = function(props) {
    var ref, ref1, ref2;
    var trackedContentItems = useContentPercentViewed();
    var ref3 = (0,config["default"])(), _publicRuntimeConfig = ref3.publicRuntimeConfig, museWebHost = _publicRuntimeConfig.museWebHost, apiBase = _publicRuntimeConfig.apiBase;
    var initialAppParams = props.initialAppParams, statusCode = props.statusCode, featureFlags = props.featureFlags;
    var initialAppState = initialAppParams;
    var pageLayoutProps = {
        activePath: "/search",
        headerClassName: (Home_module_default()).pageHeader,
        pageName: (Home_module_default()).pageWrapper,
        mainClassName: (Home_module_default()).main,
        enableSearch: true,
        searchUrl: "/search",
        onSearchSubmit: handleSearchSubmit
    };
    var jobTrackingProps = (0,tracking/* getJobTrackingProps */.Cg)(initialAppState === null || initialAppState === void 0 ? void 0 : initialAppState.job, initialAppState === null || initialAppState === void 0 ? void 0 : initialAppState.company);
    var job = initialAppState.job, company = initialAppState.company;
    var physicalLocations = job === null || job === void 0 ? void 0 : (ref = job.locations) === null || ref === void 0 ? void 0 : ref.filter(function(location) {
        return (location === null || location === void 0 ? void 0 : location.value) !== "Flexible / Remote";
    });
    var firstLocation = (physicalLocations === null || physicalLocations === void 0 ? void 0 : (ref1 = physicalLocations[0]) === null || ref1 === void 0 ? void 0 : ref1.value) || "";
    var firstlocationDisplay = firstLocation ? " located in ".concat(firstLocation, ", ") : ", ";
    var canonical = "".concat(museWebHost, "/jobs/").concat(company === null || company === void 0 ? void 0 : company.short_name, "/").concat(job === null || job === void 0 ? void 0 : job.short_name);
    // eslint-disable-next-line max-len
    var description = "Find our ".concat(job === null || job === void 0 ? void 0 : job.name, " job description for ").concat(company === null || company === void 0 ? void 0 : company.name).concat(firstlocationDisplay, " as well as other career opportunities that the company is hiring for.");
    var noIndex = (job === null || job === void 0 ? void 0 : job.state) !== "live";
    var title = "".concat(job === null || job === void 0 ? void 0 : job.name, " at ").concat(company === null || company === void 0 ? void 0 : company.name, " | The Muse");
    // Mega Apply is small subset of companies.
    var isMegaApply = featureFlags.FEATURE_FLAG_DIRECT_APPLY_MEGA && constants/* megaApplyCompanies.includes */.$s.includes(company.short_name);
    // The direct apply POC includes jobs from the Greenhouse ATS from companies that are limited.
    // We will have to exclude specific companies.
    var isIframeApply = featureFlags.FEATURE_FLAG_DIRECT_APPLY && (job === null || job === void 0 ? void 0 : job.state) === "live" && (company.state === "limited" || company.package === "Provisional") && (job === null || job === void 0 ? void 0 : (ref2 = job.apply_link) === null || ref2 === void 0 ? void 0 : ref2.includes("greenhouse"));
    // This controls th direct apply modal and is passed down to both the modal and the apply buttons.
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isDirectApplyModalOpen = ref4[0], setIsDirectApplyModalOpen = ref4[1];
    // if we pass a function use it otherwise we are a normal link.
    var setIsOpen = isMegaApply || isIframeApply ? setIsDirectApplyModalOpen : null;
    react.useEffect(function() {
        if ((trackedContentItems === null || trackedContentItems === void 0 ? void 0 : trackedContentItems.length) > 0) {
            (0,tracking/* museTrack */.YU)("Job Scrolled", (0,src_object_spread/* default */.Z)({}, jobTrackingProps, trackedContentItems[trackedContentItems.length - 1]));
        }
    }, [
        trackedContentItems
    ]);
    react.useEffect(function() {
        if ((trackedContentItems === null || trackedContentItems === void 0 ? void 0 : trackedContentItems.length) > 0) {
            (0,tracking/* museTrack */.YU)("Job Scrolled", (0,src_object_spread/* default */.Z)({}, jobTrackingProps, trackedContentItems[trackedContentItems.length - 1]));
        }
    }, [
        trackedContentItems
    ]);
    var iframeApplyProps = {
        isOpen: isDirectApplyModalOpen,
        setIsOpen: setIsOpen,
        link: job.apply_link
    };
    var megaApplyProps = {
        isOpen: isDirectApplyModalOpen,
        setIsOpen: setIsOpen,
        link: job === null || job === void 0 ? void 0 : job.apply_link,
        jobId: "".concat(job.id),
        companyId: "".concat(company.id),
        jobName: job.name,
        companyName: company.name,
        locations: job.locations.map(function(loc) {
            return loc.value;
        }),
        endpoint: "".concat(apiBase, "/mega_apply")
    };
    (0,react.useEffect)(function() {
        (0,tracking/* museTrack */.YU)("Page Loaded", {
            status_code: statusCode
        });
        (0,tracking/* museTrack */.YU)("Job Individual Page Loaded", jobTrackingProps);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsProvider, {
        featureFlags: featureFlags,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppContext/* AppProvider */.wI, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialAppState), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    title: title,
                    description: description,
                    canonical: canonical,
                    openGraph: {
                        url: canonical,
                        title: title,
                        description: description
                    },
                    noindex: noIndex
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostJsonLd, {
                    isDirectApply: isMegaApply || isIframeApply
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInit, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobIndividualPageLayout, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pageLayoutProps), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobIndividualHeader, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobIndividualBody, {
                                setIsOpen: setIsOpen,
                                isDirectApply: isMegaApply || isIframeApply
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobIndividualSidebar, {
                                getSimilarJobs: getSimilarJobs,
                                setIsOpen: setIsOpen,
                                isDirectApply: isMegaApply || isIframeApply
                            }),
                            isMegaApply && /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* DirectApply */.i3, (0,src_object_spread/* default */.Z)({}, megaApplyProps)),
                            !isMegaApply && isIframeApply && /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectApplyModal, (0,src_object_spread/* default */.Z)({}, iframeApplyProps))
                        ]
                    }))
                })
            ]
        }))
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 9039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"additionalJobLinkList":"AdditionalJobLinkList_additionalJobLinkList__a2hQn","linkHeader":"AdditionalJobLinkList_linkHeader__HTLuf","linkListContainer":"AdditionalJobLinkList_linkListContainer__LO4gs","limitedList":"AdditionalJobLinkList_limitedList__HtEEM","fullList":"AdditionalJobLinkList_fullList__wxda2","singleJobLink":"AdditionalJobLinkList_singleJobLink__IRztK","gradientOverlay":"AdditionalJobLinkList_gradientOverlay__HH3H_","noGradient":"AdditionalJobLinkList_noGradient__rAzRp","viewAllContentContainer":"AdditionalJobLinkList_viewAllContentContainer__Y6uUt","viewAllSeparatorLine":"AdditionalJobLinkList_viewAllSeparatorLine__9CAOI","viewMoreButton":"AdditionalJobLinkList_viewMoreButton__nRygu","arrowUpAlignment":"AdditionalJobLinkList_arrowUpAlignment__rLbfG","arrowStyling":"AdditionalJobLinkList_arrowStyling__lG1JH"};

/***/ }),

/***/ 1530:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"companyInformationModule":"CompanyInformationModule_companyInformationModule__2M32l","desktop":"CompanyInformationModule_desktop__Dhg3G","mobile":"CompanyInformationModule_mobile__9vC65","companyLogo":"CompanyInformationModule_companyLogo__wvWl2","companyShortDescription":"CompanyInformationModule_companyShortDescription__Hr_fW","companyProfileLink":"CompanyInformationModule_companyProfileLink__sRyue","hasPhoto":"CompanyInformationModule_hasPhoto__k3Kxh"};

/***/ }),

/***/ 1676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobApplyModalContainer":"DirectApplyModal_jobApplyModalContainer__tZNqX","jobApplyModalContent":"DirectApplyModal_jobApplyModalContent__fgJOX","jobApplyModalCloseButton":"DirectApplyModal_jobApplyModalCloseButton__3ujbG"};

/***/ }),

/***/ 3417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobAlerts":"JobAlert_jobAlerts__ohuSX"};

/***/ }),

/***/ 5810:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobApplyContainer":"JobApplyButtonSideBarModule_jobApplyContainer__Hlere","applyButton":"JobApplyButtonSideBarModule_applyButton__h7WCR","archivedJobMessage":"JobApplyButtonSideBarModule_archivedJobMessage__nS3YO"};

/***/ }),

/***/ 6766:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobBodyContainer":"JobIndividualBody_jobBodyContainer__rQGA_","jobBodyDescription":"JobIndividualBody_jobBodyDescription__NTB3f","jobBodyFooter":"JobIndividualBody_jobBodyFooter__GRqS9","applyContainer":"JobIndividualBody_applyContainer__ffb_U","jobBodyJWPlayerVideo":"JobIndividualBody_jobBodyJWPlayerVideo__XAlZ9","applyButton":"JobIndividualBody_applyButton__XMXE4","perksAndBenefits":"JobIndividualBody_perksAndBenefits__Eul6J"};

/***/ }),

/***/ 5870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobHeaderContainer":"JobIndividualHeader_jobHeaderContainer__GyMg1","jobHeaderCompanyName":"JobIndividualHeader_jobHeaderCompanyName__PKqdn","jobHeaderTitle":"JobIndividualHeader_jobHeaderTitle__wA3d3","jobHeaderSubHeading":"JobIndividualHeader_jobHeaderSubHeading__nRAGH","jobHeaderSeparator":"JobIndividualHeader_jobHeaderSeparator__d5Um7","jobHeaderLocation":"JobIndividualHeader_jobHeaderLocation__Tyroc"};

/***/ }),

/***/ 5950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobSidebarContainer":"JobIndividualSidebar_jobSidebarContainer__eX5_t","sidebarModules":"JobIndividualSidebar_sidebarModules__elgun","similarJobsModule":"JobIndividualSidebar_similarJobsModule__QDX2z","suggestedSearchesModule":"JobIndividualSidebar_suggestedSearchesModule__snmNH"};

/***/ }),

/***/ 4865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseGrid":"Home_baseGrid__5iHw2","main":"Home_main__zgAJj Home_baseGrid__5iHw2","pageHeader":"Home_pageHeader__Y8w6l"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [452,817,112,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);